//React
import React, { Component } from 'react';
import crypto from 'crypto'

//Redux
import { withRouter } from "react-router-dom";

//UI
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faEdit, faChevronDown, FaArrowsAltH } from '@fortawesome/free-solid-svg-icons';
import { Row, Col, Form, Card, Container, FormInput, FormSelect, Button, InputGroupText, InputGroupAddon, FormRadio, FormCheckbox } from "shards-react";
import { Table, Nav, NavItem, NavLink } from 'reactstrap';
import { Dialog,DialogContent, DialogActions, DialogTitle, DialogContentText } from '@material-ui/core';
import classnames from 'classnames';

import TituloPagina from "../components/common/TituloPagina";

import NewMasterFile from "../components/masterfiles/NewMasterFile";
import NewMasterFileContractOther from "../components/masterfiles/NewMasterFileContractOther";
import NewMasterFileContractUpload from "../components/masterfiles/NewMasterFileContractUpload";

import NewIoTDevice from "../components/iotdevice/NewIoTDevice";

// blockstack
//import { UserSession } from 'blockstack';
import { UserSession } from '@stacks/auth';
import { Storage } from '@stacks/storage'

//translate
import { FormattedMessage } from 'react-intl';

//base64
import { Base64 } from 'js-base64';
import forge from 'node-forge'

import { triggerBase64Download } from 'react-base64-downloader';

//Currency
import currency from '../utils/currency';
import currencyCrypto from '../utils/currency-crypto';
import currencyPayment from '../utils/currency-payment';

import ContractLoader from "../components/contracts/ContractLoader";
import MyDownload from '../components/contractattachfile//MyDownload';

import {username_new} from '../actions/userActions'
import {profileUser} from '../actions/gaiaActions'

import {getFileDB, putFileDB} from '../actions/mongoDBActions'

import "../components/contracts/tab.css";

// React-Table
//import ReactTable from 'react-table'
//import 'react-table/react-table.css'

function Confirmacion(props) {
    return (
        <Dialog
            open={props.dialogOpen}
            onClose={() => props.handleDialog('cancel')}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{props.dialogTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {props.dialogMessage}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.handleDialog(props.dialogTitle, 'cancel')} theme="warning" autoFocus>
                    <FormattedMessage id="alert.cancel" />
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function Confirmacion2(props) {
    return (
        <Dialog
            open={props.dialogOpen}
            onClose={() => props.handleDialog('cancel')}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{props.dialogTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {props.dialogMessage}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.handleDialog(props.dialogTitle, 'cancel')} theme="warning" autoFocus>
                    <FormattedMessage id="alert.cancel" />
                </Button>
                <Button onClick={() => props.handleDialog(props.dialogTitle, 'confirm')} theme="danger">
                    <FormattedMessage id="alert.confirm" />
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function Confirmacion3(props) {
    return (
        <Dialog
            open={props.dialogOpen}
            onClose={() => props.handleDialog('exit')}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{props.dialogTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {props.dialogMessage}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.handleDialog(props.dialogTitle, 'exit')} theme="success" autoFocus>
                    <FormattedMessage id="pay.exit" />
                </Button>
            </DialogActions>
        </Dialog>
    );
}

function Confirmacion4(props) {
    return (
        <Dialog
            open={props.dialogOpen}
            onClose={() => props.handleDialog('exit')}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{props.dialogTitle}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {props.dialogMessage}
                </DialogContentText>
                <br></br>
                <DialogContentText id="alert-dialog-description">
                  Ingrese su ID Usuario:
                  <FormInput
                    id="IDUsuario"
                    value={props.idUsuarioX}
                    type="text"
                    onChange={e=>props.handleIdUsuario(e)}
                  />
                </DialogContentText>

            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.handleDialog(props.dialogTitle, 'cancel')} theme="warning" autoFocus>
                    <FormattedMessage id="alert.cancel" />
                </Button>
                <Button disabled={props.idUsuarioDisabledX} onClick={() => props.handleDialog(props.dialogTitle, 'confirm')} theme="danger">
                    <FormattedMessage id="alert.confirm" />
                </Button>
            </DialogActions>
        </Dialog>
    );
}

class ConntenedorMasterFile extends Component {

    constructor(props) {
        super(props);

        this.goMasterFile = this.goMasterFile.bind(this);
        this.goMasterFileDeliverable = this.goMasterFileDeliverable.bind(this);
        this.clickRemoveMasterFile = this.clickRemoveMasterFile.bind(this);
        this.clickEditMasterFile = this.clickEditMasterFile.bind(this);
        this.crearMasterFile = this.crearMasterFile.bind(this);
        this.handleChangeOption = this.handleChangeOption.bind(this);
        this.handleDialog = this.handleDialog.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeRole = this.handleChangeRole.bind(this);
        this.handleChangeNumber = this.handleChangeNumber.bind(this);
        this.handleBlurNumber = this.handleBlurNumber.bind(this);
        this.handleInputNumber = this.handleInputNumber.bind(this);
        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.deleteConfirmRole = this.deleteConfirmRole.bind(this);
        this.deleteConfirmDevice = this.deleteConfirmDevice.bind(this);
        this.deleteConfirmDeviceContract = this.deleteConfirmDeviceContract.bind(this);
        this.serverConfirm = this.serverConfirm.bind(this);
        this.saveSetting = this.saveSetting.bind(this);
        this.clickRemoveSetting = this.clickRemoveSetting.bind(this);
        this.clickEditSetting = this.clickEditSetting.bind(this);
        this.newSetting = this.newSetting.bind(this);
        this.goSetting = this.goSetting.bind(this);
        this.goDetailSetting = this.goDetailSetting.bind(this);
        this.goDetailContracts = this.goDetailContracts.bind(this);
        this.clickRemoveIoTDevice = this.clickRemoveIoTDevice.bind(this);
        this.clickEditIoTDevice = this.clickEditIoTDevice.bind(this);
        this.crearIoTDevice = this.crearIoTDevice.bind(this);
        this.goIoTDevice = this.goIoTDevice.bind(this);
        this.goDetailIoTDevice = this.goDetailIoTDevice.bind(this);
        this.goDetailRole = this.goDetailRole.bind(this);
        this.goDetailTag = this.goDetailTag.bind(this);
        this.verificateDevice = this.verificateDevice.bind(this);
        this.verificateSensor = this.verificateSensor.bind(this);
        this.verificateDeviceSensor = this.verificateDeviceSensor.bind(this);
        this.verificateContractList = this.verificateContractList.bind(this);
        this.verificateContractList_2 = this.verificateContractList_2.bind(this);
        this.verificateUserGroupRole = this.verificateUserGroupRole.bind(this);
        this.verificateRules = this.verificateRules.bind(this);
        this.verificateRulesDevice = this.verificateRulesDevice.bind(this);
        this.clickUpdateContracts = this.clickUpdateContracts.bind(this);
        this.clickOther = this.clickOther.bind(this);
        this.resetSetting = this.resetSetting.bind(this);
        this.dataSimulatorConfirm = this.dataSimulatorConfirm.bind(this);

        this.state = {
          userSession: new UserSession(),
          username: '',
          user: {},
          opcionMasterFile: '',
          displayMasterFile: false,
          jsonBlockstack: [],
          jsonBlockstack2: [],
          typeMasterFile: '',
          selectedConfiguration: 'General',

          activeTab: '1',
          opcionRole: '',
          displayRole: false,
          typeRole: '',

          opcionSetting: '',
          displaySetting: false,
          jsonBlockstackY: [],
          jsonBlockstackZ: [],
          typeSetting: '',
          modeSetting1: false,
          modeSetting2: false,
          modeSetting3: false,
          modeSetting4: false,
          modeSetting5: false,
          modeSetting6: false,
          modeSetting7: false,
          modeSetting8: false,
          modeSetting9: false,
          modeSetting10: false,
          modeSetting11: false,
          modeSetting12: false,
          modeSetting13: false,
          modeSetting14: false,
          modeSetting15: false,
          modeSetting16: false,
          modeSetting17: false,
          modeSetting18: false,
          modeSetting19: false,
          modeSetting20: false,
          existSetting: false,
          idx: '',

          opcionIoTDevice: '',
          displayIoTDevice: false,
          displayIoTDevice2: false,
          typeIoTDevice: '',
          dialogOpen: false,
          dialogOpenInfo: false,
          dialogOpenServer: false,
          dialogOpenCargaDato: false,
          dialogMessage: '',
          dialogTitle: '',
          language: 'English',
          templatesAllLocal: [],
          code: '',
          description: '',
          colorletter: '',
          hex: '',
          modifying: false,
          jsonRol: {},
          displayOther: false,
          nameOther: '',
          titleOther: '',
          priorityOther: '',
          taxOther: '',
          file: '',
          saveBringServer: true,
          secondaryName: '',
          encryptDecryptFile: 'Yes',
          paymentform: true,
          participants: true,
          pay:true,
          trace:true,
          deliverable:true,
          network:true,
          addons:true,
          activarparticipants:true,
          certificarfirma:true,
          activarentregable:true,
          certificarreglas:true,
          setItemInfo: null,
          colorDark: false,
          bEditRango: false,
          displayDiametroOcupadoKPI: false,
          jsonDiametroOcupado:[],
          codeDiametroOcupado: '',
          descriptionDiametroOcupado: '',

          idUsuarioDisabledX: true,
          idUsuarioX: '',
          remoteUserX: '',
          activeRemoteUser: false,
          jsonBackupRestore: [],
          jsonContractList: [],
          sendfiles: true,
          completedata: false,
          backupfiles: false,
          restorefiles: true,
          uploadfiles: true,
          exitprogram: true,

          displayLoader: false,
          filedecodeAttachX: '',
          downloadX: false,
          attachJson: false,
          filedecodeAttachJsonX: '',
          fileAttachJsonX: '',

        }
    }

    c01MasterFile = React.createRef();
    c01Setting = React.createRef();
    c02Setting = React.createRef();
    c01IoTDevice = React.createRef();

    UNSAFE_componentWillMount() {
      const { userSession } = this.state
      let stacksNetX = ''
      let serverStacksX = ''
      if (userSession.isUserSignedIn()) {
        const user = userSession.loadUserData()
        this.setState({ user })
        if (!localStorage["serverStacks"]) {
          serverStacksX = 'MainNet'
        }else{
          serverStacksX = localStorage.getItem('serverStacks')
        }
        if (serverStacksX === 'MainNet'){
  	       stacksNetX =  user.profile.stxAddress.mainnet
        }
        if (serverStacksX === 'TestNet'){
  	       stacksNetX =  user.profile.stxAddress.testnet
        }
      }

      const languageX = localStorage.getItem('language')
      if (languageX === undefined || languageX === ''){
        this.setState({ language: 'English' })
      }else{
        this.setState({ language: languageX })
      }

      let colorThemeX = 'Blue'
      if (localStorage["colorTheme"]) {
        colorThemeX = localStorage.getItem('colorTheme')
        if (colorThemeX === 'Dark') {
           this.setState({colorDark: true})
        }
      }

      this.setState({code:'',description:''})

      const {username} = userSession.loadUserData();
      if (username === '' || username === undefined || username === null){
        username_new(stacksNetX).then(val => {
          this.setState({username: val})
          Promise.all(
             [this.goDetailSetting(val)]
          ).then(
            (resolve) =>{},
            (reject) =>{}
          )
        })
      }else{
        this.setState({ username })
        Promise.all(
           [this.goDetailSetting(username)]
        ).then(
          (resolve) =>{},
          (reject) =>{}
        )
      }
    }

    onMouseEnterHandler = (i) =>{
      this.setState({setItemInfo: i})
    }

    onMouseLeaveHandler = (i) => {
    }


    handleChangeOption(optSearch) {
        this.setState({
          selectedConfiguration: optSearch,
          jsonBlockstack: [],
          displayMasterFile: false,
          displayOther: false,
          displayIoTDevice: false,
          displayIoTDevice2: false,
          modifying: false,
        });
        if (optSearch==="General"){
          this.setState({activeTab: '1'});
          this.goDetailSetting(this.state.username)
        }
        if (optSearch==="Role"){
          this.setState({activeTab: '2'});
          this.goDetailRole()
          this.setState({typeMasterFile: "role"})
        }
        if (optSearch==="Contracts"){
          this.setState({activeTab: '3'});
          this.goDetailContracts()
        }
        if (optSearch==="ContractMasterFile"){
          this.setState({activeTab: '4'});
          this.setState({typeMasterFile: "masterfile"})
        }
        if (optSearch==="ContractMasterFileIoT"){
          this.setState({activeTab: '10'});
          this.setState({typeMasterFile: "masterfileIoT"})
        }
        if (optSearch==="ContractMasterFileDeliverable"){
          this.setState({activeTab: '9'});
          this.setState({typeMasterFile: "masterfileDeliverable"})
        }
        if (optSearch==="IoTDevice"){
          this.setState({activeTab: '5'});
          this.goDetailIoTDevice()
        }
        if (optSearch==="Tag"){
          this.setState({activeTab: '6'});
          this.goDetailTag()
          this.setState({typeMasterFile: "tag"})
        }
        if (optSearch==="QuickSimulator"){
          //window.location = '/simulator'
          this.dataSimulatorConfirm()
        }
        if (optSearch==="BackupRestore"){
          //window.location = '/underconstruction'
          const path = '/underconstruction'
          this.setState({activeTab: '8'});
          //this.props.history.push(path);
        }
    }

    backupRestoreConfirm0 = (e) => {
      e.preventDefault();
      this.setState({displayLoader:true})
      Promise.all(
          [this.backupRestoreConfirm()]
        ).then(
          (resolve) =>{},
          (reject) =>{}
        )
    }

    backupRestoreConfirm = async () => {
      const {userSession} = this.state
      const storage = new Storage({ userSession });
      const salida = []
      let itemX = 1
      await storage.listFiles((fileContents) => {
             console.log(fileContents)
             salida.push({item:itemX, username: this.state.username, namefile: fileContents, dataobject: false, respaldado: false, datahidden: null, recoveryobject: false})
             itemX = itemX + 1
             return true
      })
      this.setState({jsonBackupRestore:salida})
      this.setState({sendfiles:false, completedata: true, backupfiles: false, uploadfiles: true, restorefiles: true, exitprogram: true, attachJson: false,})
      this.setState({displayLoader:false})

    }

    backupRestoreConfirm2 = (e, jsonBackupRestore) => {
      e.preventDefault();
      const {userSession} = this.state
      const largoX = jsonBackupRestore.length
      jsonBackupRestore.map( (todo, i) => {
          if (todo.dataobject === false) {
              Promise.all(
                 [this.backupRestoreConfirm3(todo.username,todo.namefile)]
              ).then(
                (resolve) =>{
                  todo.dataobject = resolve[0].status
                  todo.datahidden = resolve[0].salida
                 this.setState({jsonBackupRestore:jsonBackupRestore})
                },
                (reject) =>{
                  todo.dataobject = false
                  todo.datahidden = ''
                  this.setState({jsonBackupRestore:jsonBackupRestore})
                }
              )
          }
          if (i  === largoX - 1){
            this.setState({sendfiles:false, completedata: true, backupfiles: true, uploadfiles: true, restorefiles: true, exitprogram: true, attachJson: false,})
          }
      })
    }

    backupRestoreConfirm3 = (username,namefile) => {
      const {userSession} = this.state
      const storage = new Storage({ userSession });
      const options = { decrypt: false, verify: false }
      return new Promise ((resolve1, reject1) =>{
        storage.getFile(`${namefile}`, options)
            .then((fileContents) => {
              if(fileContents) {
                const jsonBlockstack1 = fileContents.replace(/\\/g,"")
                let jsonBlockstack3 = jsonBlockstack1
                if (jsonBlockstack1.substring(0,1)==='"') {
                   jsonBlockstack3 = jsonBlockstack1.substring(1,jsonBlockstack1.length - 1);
                }
                const jsonBlockstack4 = JSON.parse(jsonBlockstack3)
                resolve1({status: true, salida:Base64.encode(jsonBlockstack3)})
              } else {
                resolve1({status: false, salida:''})
              }
            })
           .catch(error => {
              resolve1({status: false, salida:''})
           });
       })
    }

    backupRestoreConfirm3X = (username,namefile) => {
      const {userSession} = this.state
      const storage = new Storage({ userSession });
      const options = { decrypt: false, verify: false }
      return new Promise ((resolve1, reject1) =>{
        getFileDB(username, `${namefile}`)
           .then((fileContents) => {
             if(fileContents) {
               const jsonBlockstack1 = JSON.parse(fileContents)
               const jsonBlockstack2 = jsonBlockstack1.data
               let jsonBlockstack5 = '[]'
               if (jsonBlockstack2 !== null){
                  const jsonBlockstack3 = jsonBlockstack2.dataobject
                  const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                  if (jsonBlockstack4.substring(0,1) === '"') {
                     jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                  } else {
                     jsonBlockstack5 = jsonBlockstack4
                  }
               }
               let jsonBlockstack6 = JSON.parse(jsonBlockstack5)

               resolve1({status: true, salida:Base64.encode(jsonBlockstack5)})
             } else {
               resolve1({status: false, salida:''})
             }
           })
          .catch(error => {
             resolve1({status: false, salida:''})
          });
       })
    }

    recoveryRestoreConfirm2 = (e, jsonBackupRestore) => {
      e.preventDefault();
      const {userSession} = this.state
      const largoX = jsonBackupRestore.length
      jsonBackupRestore.map( (todo, i) => {
          if (todo.dataobject === true && todo.recoveryobject === false && (todo.datahidden !== null && todo.datahidden !== '' )) {
              Promise.all(
                 [this.recoveryRestoreConfirm3(todo.username,todo.namefile,todo.datahidden)]
              ).then(
                (resolve) =>{
                  todo.recoveryobject = resolve[0].status
                  this.setState({jsonBackupRestore:jsonBackupRestore})
                },
                (reject) =>{
                  todo.recoveryobject = false
                  this.setState({jsonBackupRestore:jsonBackupRestore})
                }
              )
          }
          if (i  === largoX - 1){
            this.setState({sendfiles:false, completedata: true, backupfiles: true, uploadfiles: true, restorefiles: true, exitprogram: true, attachJson: true,})
          }
      })
    }

    recoveryRestoreConfirm3 = (username,namefile,data) => {
      const {userSession} = this.state
      const storage = new Storage({ userSession });
      const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
      const dataX = Base64.decode(data)
      return new Promise ((resolve1, reject1) =>{
        putFileDB(username, `${namefile}`, 'Crosscheck_Setting', JSON.stringify(dataX), JSON.stringify(options))
          .then(() => {
            resolve1({status: true})
          })
          .catch(error => {
             resolve1({status: false})
          });
       })
    }


    handleDialog = (type, action) => {
      if (type === 'Error: 1001') {
          if (action === 'cancel') {
            this.setState({ dialogOpen: false });
          }
      }
      if (type === 'Warning: 2001') {
        if (action === 'confirm') {
          this.setState({ dialogOpenServer: false });
          const infoSetting = localStorage.getItem('infoSetting')
          this.saveSetting(infoSetting,false)
        }
        if (action === 'cancel') {
          this.setState({ dialogOpenServer: false });
        }
      }
      if (type === 'Warning: 2002') {
        if (action === 'confirm') {
          this.setState({ dialogOpenCargaDato: false });
          const path = '/simulator'
          this.setState({activeTab: '7'});
          this.props.history.push(path);
        }
        if (action === 'cancel') {
          this.setState({ dialogOpenCargaDato: false });
          this.setState({ selectedConfiguration: "General" })
          this.setState({activeTab: '1'});
          this.goDetailSetting(this.state.username)
        }
      }

      if (type === 'Confirm: 3001') {
         if (action === 'exit') {
            this.setState({ dialogOpenInfo: false });
         }
      }
    }

    handleIdUsuario = (e) => {
      let idUsuarioX = e.target.value
      let idUsuarioDisabledX = true
      if (idUsuarioX.toUpperCase() === this.state.username.toUpperCase()){
        idUsuarioDisabledX = false
      }
      this.setState({idUsuarioX, idUsuarioDisabledX})
    }

    handleChange(e,chk,i,codeX) {
      const newState = {};
      newState[chk] = !this.state[chk];
      this.setState({...this.state, ...newState, isErrorWrite: false})

      if (chk==='participants'){
        const {templatesAllLocal} = this.state
        templatesAllLocal.map((todo2, y) => {
          if (y === i) {
            /*
            if (todo2.participants === true){
              todo2.participants = false
            }else{
              if (todo2.participants === false){
                todo2.participants = true
              }
            }
            */
            const {userSession} = this.state
            const storage = new Storage({ userSession });
            const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
            putFileDB(this.state.username, `contractdoc.json`, 'Crosscheck_Setting', JSON.stringify(templatesAllLocal), JSON.stringify(options))
              .then(() => {
                 //console.log(`Grabación Exitosa (contractdoc.json)`)
              })
          }
        })
      }

      if (chk==='paymentform'){
        const {templatesAllLocal} = this.state
        templatesAllLocal.map((todo2, y) => {
          if (y === i) {
            /*
            if (todo2.paymentform === true){
              todo2.paymentform = false
            }else{
              if (todo2.paymentform === false){
                todo2.paymentform = true
              }
            }
            */
            const {userSession} = this.state
            const storage = new Storage({ userSession });
            const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
            putFileDB(this.state.username, `contractdoc.json`, 'Crosscheck_Setting', JSON.stringify(templatesAllLocal), JSON.stringify(options))
              .then(() => {
                 //console.log(`Grabación Exitosa (contractdoc.json)`)
              })
          }
        })
      }

      if (chk==='pay'){
        const {templatesAllLocal} = this.state
        templatesAllLocal.map((todo2, y) => {
          if (y === i) {
            /*
            if (todo2.pay === true){
              todo2.pay = false
            }else{
              if (todo2.pay === false){
                todo2.pay = true
              }
            }
            */
            const {userSession} = this.state
            const storage = new Storage({ userSession });
            const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
            putFileDB(this.state.username, `contractdoc.json`, 'Crosscheck_Setting', JSON.stringify(templatesAllLocal), JSON.stringify(options))
              .then(() => {
                 //console.log(`Grabación Exitosa (contractdoc.json)`)
              })
          }
        })
      }

      if (chk==='certification'){
        const {templatesAllLocal} = this.state
        templatesAllLocal.map((todo2, y) => {
          if (y === i) {
            if (todo2.certification === true){
              todo2.certification = false
            }else{
              if (todo2.certification === false){
                todo2.certification = true
              }
            }
            const {userSession} = this.state
            const storage = new Storage({ userSession });
            const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
            putFileDB(this.state.username, `contractdoc.json`, 'Crosscheck_Setting', JSON.stringify(templatesAllLocal), JSON.stringify(options))
              .then(() => {
                 //console.log(`Grabación Exitosa (contractdoc.json)`)
              })
          }
        })
      }

      if (chk==='deliverable'){
        const {templatesAllLocal} = this.state
        templatesAllLocal.map((todo2, y) => {
          if (y === i) {
            /*
            if (todo2.deliverable === true){
              todo2.deliverable = false
            }else{
              if (todo2.deliverable === false){
                todo2.deliverable = true
              }
            }
            */
            const {userSession} = this.state
            const storage = new Storage({ userSession });
            const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
            putFileDB(this.state.username, `contractdoc.json`, 'Crosscheck_Setting', JSON.stringify(templatesAllLocal), JSON.stringify(options))
              .then(() => {
                 //console.log(`Grabación Exitosa (contractdoc.json)`)
              })
          }
        })
      }

      if (chk==='trace'){
        const {templatesAllLocal} = this.state
        templatesAllLocal.map((todo2, y) => {
          if (y === i) {
            if (todo2.trace === true){
              todo2.trace = false
            }else{
              if (todo2.trace === false){
                todo2.trace = true
              }
            }
            const {userSession} = this.state
            const storage = new Storage({ userSession });
            const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
            putFileDB(this.state.username, `contractdoc.json`, 'Crosscheck_Setting', JSON.stringify(templatesAllLocal), JSON.stringify(options))
              .then(() => {
                 //console.log(`Grabación Exitosa (contractdoc.json)`)
              })
          }
        })
      }


      if (chk==='network'){
        const {templatesAllLocal} = this.state
        templatesAllLocal.map((todo2, y) => {
          if (y === i) {
            if (todo2.network === true){
              todo2.network = false
            }else{
              if (todo2.network === false){
                todo2.network = true
              }
            }
            const {userSession} = this.state
            const storage = new Storage({ userSession });
            const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
            putFileDB(this.state.username, `contractdoc.json`, 'Crosscheck_Setting', JSON.stringify(templatesAllLocal), JSON.stringify(options))
              .then(() => {
                 //console.log(`Grabación Exitosa (contractdoc.json)`)
              })
          }
        })
      }

      if (chk==='addons'){
        const {templatesAllLocal} = this.state
        templatesAllLocal.map((todo2, y) => {
          if (y === i) {
            if (todo2.addons === true){
              todo2.addons = false
            }else{
              if (todo2.addons === false){
                todo2.addons = true
              }
            }
            const {userSession} = this.state
            const storage = new Storage({ userSession });
            const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
            putFileDB(this.state.username, `contractdoc.json`, 'Crosscheck_Setting', JSON.stringify(templatesAllLocal), JSON.stringify(options))
              .then(() => {
                 //console.log(`Grabación Exitosa (contractdoc.json)`)
              })
          }
        })
      }

      if (chk==='certificates'){
        const {templatesAllLocal} = this.state
        templatesAllLocal.map((todo2, y) => {
          if (y === i) {
            if (todo2.certificates === true){
              todo2.certificates = false
            }else{
              if (todo2.certificates === false){
                todo2.certificates = true
              }
            }
            const {userSession} = this.state
            const storage = new Storage({ userSession });
            const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
            putFileDB(this.state.username, `contractdoc.json`, 'Crosscheck_Setting', JSON.stringify(templatesAllLocal), JSON.stringify(options))
              .then(() => {
                 //console.log(`Grabación Exitosa (contractdoc.json)`)
              })
          }
        })
      }

      if (chk==='isActive'){
        if (codeX !== 'Environment & Sustainability' && codeX !== 'Manufacturing' && codeX !== 'Rental Contracts' && codeX !== 'Security') {
          const {templatesAllLocal} = this.state
          templatesAllLocal.map((todo2, y) => {
            if (y === i) {
              if (todo2.isActive === true){
                todo2.isActive = false
                todo2.participants = false
                todo2.paymentform = false
                todo2.pay = false
                todo2.deliverable = false
                todo2.trace = false
                todo2.network = false
                todo2.addons = false
                todo2.certificates = false
              }else{
                if (todo2.isActive === false){
                  if (codeX === 'Work Order'){
                    todo2.isActive = true
                    todo2.participants = true
                    todo2.paymentform = false
                    todo2.pay = false
                    todo2.deliverable = true
                    todo2.trace = false
                    todo2.network = true
                    todo2.addons = false
                    todo2.certificates = false
                  }else{
                    todo2.isActive = true
                    todo2.participants = true
                    todo2.paymentform = true
                    todo2.pay = true
                    todo2.deliverable = true
                    todo2.trace = false
                    todo2.network = false
                    todo2.addons = false
                    todo2.certificates = true
                  }
                }
              }
              const {userSession} = this.state
              const storage = new Storage({ userSession });
              const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
              putFileDB(this.state.username, `contractdoc.json`, 'Crosscheck_Setting', JSON.stringify(templatesAllLocal), JSON.stringify(options))
                .then(() => {
                   //console.log(`Grabación Exitosa (contractdoc.json)`)
                })
            }
          })
        }
      }
    }

    handleChangeRole(e,chk,i,codeX) {
      if (codeX === 'Creator' || codeX === 'Authorizer' || codeX === 'Observer' ||
          codeX === 'Support' || codeX === 'Payer' || codeX === 'PayTo') {
          return
      }
      const newState = {};
      newState[chk] = !this.state[chk];
      this.setState({...this.state, ...newState, isErrorWrite: false})

      if (chk==='pay'){
        const {jsonBlockstack} = this.state
        jsonBlockstack.map((todo2, y) => {
          if (y === i) {
            if (todo2.pay === true){
              todo2.pay = false
            }else{
              if (todo2.pay === false){
                todo2.pay = true
              }
            }
            const {userSession} = this.state
            const storage = new Storage({ userSession });
            const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
            putFileDB(this.state.username, `role.json`, 'Crosscheck_Setting', JSON.stringify(jsonBlockstack), JSON.stringify(options))
              .then(() => {
                 //console.log(`Grabación Exitosa (role.json)`)
              })
          }
        })
      }

      if (chk==='network'){
        const {jsonBlockstack} = this.state
        jsonBlockstack.map((todo2, y) => {
          if (y === i) {
            if (todo2.network === true){
              todo2.network = false
            }else{
              if (todo2.network === false){
                todo2.network = true
              }
            }
            const {userSession} = this.state
            const storage = new Storage({ userSession });
            const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
            putFileDB(this.state.username, `role.json`, 'Crosscheck_Setting', JSON.stringify(jsonBlockstack), JSON.stringify(options))
              .then(() => {
                 //console.log(`Grabación Exitosa (role.json)`)
              })
          }
        })
      }
    }

    handleChangeNumber(e,chk) {
    }

    handleBlurNumber(e,chk) {
    }

    handleInputNumber(e,chk) {
        if (chk==='PriorityContract'){
          if (this.cPriorityContract.current.value.length===0){
             this.cPriorityContract.current.value = ''
          }
        }
    }

    dataSimulatorConfirm() {
      if (this.state.language === 'English'){this.setState({dialogOpenCargaDato: true,dialogMessage: 'Caution: Local contract settings will be lost, do you want to continue?',dialogTitle: 'Warning: 2002',})}
      if (this.state.language === 'French'){this.setState({dialogOpenCargaDato: true,dialogMessage: "Attention: les paramètres du contrat local seront perdus, souhaitez-vous continuer?",dialogTitle: 'Warning: 2002',})}
      if (this.state.language === 'Spanish'){this.setState({dialogOpenCargaDato: true,dialogMessage: 'Precaución: Se perderán las configuraciones locales de los contratos, ¿desea continuar?',dialogTitle: 'Warning: 2002',})}
      if (this.state.language === 'Portuguese'){this.setState({dialogOpenCargaDato: true,dialogMessage: 'Cuidado: as configurações do contrato local serão perdidas. Deseja continuar?',dialogTitle: 'Warning: 2002',})}
      if (this.state.language === 'Swedish'){this.setState({dialogOpenCargaDato: true,dialogMessage: 'Varning: Lokala kontraktinställningar går förlorade, vill du fortsätta?',dialogTitle: 'Warning: 2002',})}
      if (this.state.language === 'Netherlands'){this.setState({dialogOpenCargaDato: true,dialogMessage: 'Let op: Lokale contractinstellingen gaan verloren, wilt u doorgaan?',dialogTitle: 'Warning: 2002',})}
      if (this.state.language === 'Russian'){this.setState({dialogOpenCargaDato: true,dialogMessage: 'Внимание: локальные настройки контракта будут потеряны, вы хотите продолжить?',dialogTitle: 'Warning: 2002',})}
      if (this.state.language === 'Japanese'){this.setState({dialogOpenCargaDato: true,dialogMessage: '注意：ローカル契約の設定は失われます。続行しますか？',dialogTitle: 'Warning: 2002',})}
      if (this.state.language === 'Chinese'){this.setState({dialogOpenCargaDato: true,dialogMessage: '警告：本地合同设置将丢失，您要继续吗？',dialogTitle: 'Warning: 2002',})}
      if (this.state.language === 'German'){this.setState({dialogOpenCargaDato: true,dialogMessage: 'Achtung: Lokale Vertragseinstellungen gehen verloren. Möchten Sie fortfahren?',dialogTitle: 'Warning: 2002',})}
      if (this.state.language === 'Italian'){this.setState({dialogOpenCargaDato: true,dialogMessage: 'Attenzione: le impostazioni del contratto locale andranno perse, vuoi continuare?',dialogTitle: 'Warning: 2002',})}
    }

    deleteConfirm(){
      if (this.state.language === 'English'){this.setState({dialogOpen: true, dialogMessage: 'It cannot be deleted, it is connected to a device', dialogTitle: 'Error: 1001', })}
      if (this.state.language === 'French'){this.setState({dialogOpen: true, dialogMessage: 'Il ne peut pas être supprimé, il est connecté à un appareil', dialogTitle: 'Error: 1001', })}
      if (this.state.language === 'Spanish'){this.setState({dialogOpen: true, dialogMessage: 'No se puede eliminar, está conectado a un dispositivo', dialogTitle: 'Error: 1001', })}
      if (this.state.language === 'Portuguese'){this.setState({dialogOpen: true, dialogMessage: 'Não pode ser excluído, está conectado a um dispositivo', dialogTitle: 'Error: 1001', })}
      if (this.state.language === 'Swedish'){this.setState({dialogOpen: true, dialogMessage: 'Det kan inte raderas, det är anslutet till en enhet', dialogTitle: 'Error: 1001', })}
      if (this.state.language === 'Netherlands'){this.setState({dialogOpen: true, dialogMessage: 'Het kan niet worden verwijderd, het is verbonden met een apparaat', dialogTitle: 'Error: 1001', })}
      if (this.state.language === 'Russian'){this.setState({dialogOpen: true, dialogMessage: 'Он не может быть удален, он подключен к устройству', dialogTitle: 'Error: 1001', })}
      if (this.state.language === 'Japanese'){this.setState({dialogOpen: true, dialogMessage: '削除できません。デバイスに接続されています', dialogTitle: 'Error: 1001', })}
      if (this.state.language === 'Chinese'){this.setState({dialogOpen: true, dialogMessage: '它无法删除，它连接到设备', dialogTitle: 'Error: 1001', })}
      if (this.state.language === 'German'){this.setState({dialogOpen: true, dialogMessage: 'Es kann nicht gelöscht werden, es ist mit einem Gerät verbunden', dialogTitle: 'Error: 1001', })}
      if (this.state.language === 'Italian'){this.setState({dialogOpen: true, dialogMessage: 'Non può essere eliminato, è collegato a un dispositivo', dialogTitle: 'Error: 1001', })}
    }

    deleteConfirmRole(){
      if (this.state.language === 'English'){this.setState({dialogOpen: true,dialogMessage: 'Cannot be deleted, is connected to active smart contract',dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'French'){this.setState({dialogOpen: true,dialogMessage: 'Ne peut pas être supprimé, est connecté au contrat intelligent actif',dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'Spanish'){this.setState({dialogOpen: true,dialogMessage: 'No se puede eliminar, está conectado a un contrato inteligente activo',dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'Portuguese'){this.setState({dialogOpen: true,dialogMessage: 'Não pode ser excluído, está conectado ao contrato inteligente ativo',dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'Swedish'){this.setState({dialogOpen: true,dialogMessage: 'Kan inte raderas, är ansluten till aktivt smartkontrakt',dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'Netherlands'){this.setState({dialogOpen: true,dialogMessage: 'Kan niet worden verwijderd, is verbonden met actief smart contract',dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'Russian'){this.setState({dialogOpen: true,dialogMessage: 'Невозможно удалить, подключен к активному смарт-контракту',dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'Japanese'){this.setState({dialogOpen: true,dialogMessage: '削除できません。アクティブなスマートコントラクトに接続されています',dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'Chinese'){this.setState({dialogOpen: true,dialogMessage: '无法删除，已连接到活动智能合约',dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'German'){this.setState({dialogOpen: true,dialogMessage: 'Kann nicht gelöscht werden, ist mit dem aktiven Smart-Vertrag verbunden',dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'Italian'){this.setState({dialogOpen: true,dialogMessage: 'Non può essere eliminato, è collegato al contratto intelligente attivo',dialogTitle: 'Error: 1001',})}
    }

    deleteConfirmDevice(){
      if (this.state.language === 'English'){this.setState({dialogOpen: true,dialogMessage: 'Cannot be deleted, is connected to sensors',dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'French'){this.setState({dialogOpen: true,dialogMessage: 'Ne peut pas être supprimé, est connecté à des capteurs',dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'Spanish'){this.setState({dialogOpen: true,dialogMessage: 'No se puede eliminar, está conectado a sensores',dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'Portuguese'){this.setState({dialogOpen: true,dialogMessage: 'Não pode ser excluído, está conectado aos sensores',dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'Swedish'){this.setState({dialogOpen: true,dialogMessage: 'Kan inte raderas, är ansluten till sensorer',dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'Netherlands'){this.setState({dialogOpen: true,dialogMessage: 'Kan niet worden verwijderd, is verbonden met sensoren',dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'Russian'){this.setState({dialogOpen: true,dialogMessage: 'Не может быть удален, подключен к датчикам',dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'Japanese'){this.setState({dialogOpen: true,dialogMessage: '削除できません、センサーに接続されています',dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'Chinese'){this.setState({dialogOpen: true,dialogMessage: '无法删除，连接到传感器',dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'German'){this.setState({dialogOpen: true,dialogMessage: 'Kann nicht gelöscht werden, ist an Sensoren angeschlossen',dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'Italian'){this.setState({dialogOpen: true,dialogMessage: 'Non può essere eliminato, è collegato ai sensori',dialogTitle: 'Error: 1001',})}
    }

    deleteConfirmDeviceContract(){
      if (this.state.language === 'English'){this.setState({dialogOpen: true,dialogMessage: 'Cannot be deleted, device is connected to smart contract',dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'French'){this.setState({dialogOpen: true,dialogMessage: "Ne peut pas être supprimé, l'appareil est connecté à smart contract",dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'Spanish'){this.setState({dialogOpen: true,dialogMessage: 'No se puede eliminar, el dispositivo está conectado a un contrato inteligente',dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'Portuguese'){this.setState({dialogOpen: true,dialogMessage: 'Não pode ser excluído, o dispositivo está conectado ao contrato inteligente',dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'Swedish'){this.setState({dialogOpen: true,dialogMessage: 'Det går inte att radera, enheten är ansluten till smart kontrakt',dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'Netherlands'){this.setState({dialogOpen: true,dialogMessage: 'Kan niet worden verwijderd, apparaat is verbonden met smart contract',dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'Russian'){this.setState({dialogOpen: true,dialogMessage: 'Невозможно удалить, устройство подключено к смарт-контракту',dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'Japanese'){this.setState({dialogOpen: true,dialogMessage: '削除できません。デバイスはスマートコントラクトに接続されています',dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'Chinese'){this.setState({dialogOpen: true,dialogMessage: '无法删除，设备已连接到智能合约',dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'German'){this.setState({dialogOpen: true,dialogMessage: 'Kann nicht gelöscht werden, Gerät ist mit Smart Contract verbunden',dialogTitle: 'Error: 1001',})}
      if (this.state.language === 'Italian'){this.setState({dialogOpen: true,dialogMessage: 'Non può essere eliminato, il dispositivo è collegato al contratto intelligente',dialogTitle: 'Error: 1001',})}
    }

    serverConfirm(){
      if (this.state.language === 'English'){this.setState({dialogOpenServer: true,dialogMessage: 'Caution: Local contract settings will be lost, do you want to continue?',dialogTitle: 'Warning: 2001',})}
      if (this.state.language === 'French'){this.setState({dialogOpenServer: true,dialogMessage: "Attention: les paramètres du contrat local seront perdus, souhaitez-vous continuer?",dialogTitle: 'Warning: 2001',})}
      if (this.state.language === 'Spanish'){this.setState({dialogOpenServer: true,dialogMessage: 'Precaución: Se perderán las configuraciones locales de los contratos, ¿desea continuar?',dialogTitle: 'Warning: 2001',})}
      if (this.state.language === 'Portuguese'){this.setState({dialogOpenServer: true,dialogMessage: 'Cuidado: as configurações do contrato local serão perdidas. Deseja continuar?',dialogTitle: 'Warning: 2001',})}
      if (this.state.language === 'Swedish'){this.setState({dialogOpenServer: true,dialogMessage: 'Varning: Lokala kontraktinställningar går förlorade, vill du fortsätta?',dialogTitle: 'Warning: 2001',})}
      if (this.state.language === 'Netherlands'){this.setState({dialogOpenServer: true,dialogMessage: 'Let op: Lokale contractinstellingen gaan verloren, wilt u doorgaan?',dialogTitle: 'Warning: 2001',})}
      if (this.state.language === 'Russian'){this.setState({dialogOpenServer: true,dialogMessage: 'Внимание: локальные настройки контракта будут потеряны, вы хотите продолжить?',dialogTitle: 'Warning: 2001',})}
      if (this.state.language === 'Japanese'){this.setState({dialogOpenServer: true,dialogMessage: '注意：ローカル契約の設定は失われます。続行しますか？',dialogTitle: 'Warning: 2001',})}
      if (this.state.language === 'Chinese'){this.setState({dialogOpenServer: true,dialogMessage: '警告：本地合同设置将丢失，您要继续吗？',dialogTitle: 'Warning: 2001',})}
      if (this.state.language === 'German'){this.setState({dialogOpenServer: true,dialogMessage: 'Achtung: Lokale Vertragseinstellungen gehen verloren. Möchten Sie fortfahren?',dialogTitle: 'Warning: 2001',})}
      if (this.state.language === 'Italian'){this.setState({dialogOpenServer: true,dialogMessage: 'Attenzione: le impostazioni del contratto locale andranno perse, vuoi continuare?',dialogTitle: 'Warning: 2001',})}
    }

    activeInfo = (e,i,code) => {
      if (this.state.language === 'English'){
        if (code === 'Creator'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or person who hires a service, buys, requests advice, among others ... and who pays ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Observer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Person who arbitrates or observes',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Authorizer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Person who represents a company, department or himself and who signs the document ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Support'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or person whose function is technical support and support in the installation of IoT devices',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Payer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Payment can be delegated to a company or private person ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'PayTo'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or Individual that provides service, sells, investigates, advises, among others ... and receives payment ',dialogTitle: 'Confirm: 3001',})}
      }
      if (this.state.language === 'Spanish'){
        if (code === 'Creator'){this.setState({dialogOpenInfo: true,dialogMessage: 'Empresa o persona que contrata un servicio, compra, solicita una asesoría, entre otros... y que paga',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Observer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Persona que arbitra u observa ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Authorizer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Persona que representa a una empresa, departamento o a si mismo y que firma el documento',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Support'){this.setState({dialogOpenInfo: true,dialogMessage: 'Empresa o persona cuya función es el soporte técnico y apoyo en la instalación de artefactos IoT ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Payer'){this.setState({dialogOpenInfo: true,dialogMessage: 'El pago puede ser delegado a empresa o personsa particular',dialogTitle: 'Confirm: 3001',})}
        if (code === 'PayTo'){this.setState({dialogOpenInfo: true,dialogMessage: 'Empresa o Particular que presta servicio, vende, investiga, asesora, entre otros... y que recibe el pago',dialogTitle: 'Confirm: 3001',})}
      }
      if (this.state.language === 'French'){
        if (code === 'Creator'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or person who hires a service, buys, requests advice, among others ... and who pays ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Observer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Person who arbitrates or observes',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Authorizer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Person who represents a company, department or himself and who signs the document ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Support'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or person whose function is technical support and support in the installation of IoT devices',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Payer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Payment can be delegated to a company or private person ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'PayTo'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or Individual that provides service, sells, investigates, advises, among others ... and receives payment ',dialogTitle: 'Confirm: 3001',})}
      }
      if (this.state.language === 'Portuguese'){
        if (code === 'Creator'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or person who hires a service, buys, requests advice, among others ... and who pays ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Observer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Person who arbitrates or observes',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Authorizer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Person who represents a company, department or himself and who signs the document ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Support'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or person whose function is technical support and support in the installation of IoT devices',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Payer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Payment can be delegated to a company or private person ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'PayTo'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or Individual that provides service, sells, investigates, advises, among others ... and receives payment ',dialogTitle: 'Confirm: 3001',})}
      }
      if (this.state.language === 'Swedish'){
        if (code === 'Creator'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or person who hires a service, buys, requests advice, among others ... and who pays ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Observer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Person who arbitrates or observes',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Authorizer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Person who represents a company, department or himself and who signs the document ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Support'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or person whose function is technical support and support in the installation of IoT devices',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Payer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Payment can be delegated to a company or private person ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'PayTo'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or Individual that provides service, sells, investigates, advises, among others ... and receives payment ',dialogTitle: 'Confirm: 3001',})}
      }
      if (this.state.language === 'Netherlands'){
        if (code === 'Creator'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or person who hires a service, buys, requests advice, among others ... and who pays ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Observer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Person who arbitrates or observes',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Authorizer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Person who represents a company, department or himself and who signs the document ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Support'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or person whose function is technical support and support in the installation of IoT devices',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Payer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Payment can be delegated to a company or private person ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'PayTo'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or Individual that provides service, sells, investigates, advises, among others ... and receives payment ',dialogTitle: 'Confirm: 3001',})}
      }
      if (this.state.language === 'Russian'){
        if (code === 'Creator'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or person who hires a service, buys, requests advice, among others ... and who pays ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Observer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Person who arbitrates or observes',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Authorizer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Person who represents a company, department or himself and who signs the document ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Support'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or person whose function is technical support and support in the installation of IoT devices',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Payer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Payment can be delegated to a company or private person ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'PayTo'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or Individual that provides service, sells, investigates, advises, among others ... and receives payment ',dialogTitle: 'Confirm: 3001',})}
      }
      if (this.state.language === 'Japanese'){
        if (code === 'Creator'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or person who hires a service, buys, requests advice, among others ... and who pays ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Observer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Person who arbitrates or observes',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Authorizer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Person who represents a company, department or himself and who signs the document ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Support'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or person whose function is technical support and support in the installation of IoT devices',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Payer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Payment can be delegated to a company or private person ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'PayTo'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or Individual that provides service, sells, investigates, advises, among others ... and receives payment ',dialogTitle: 'Confirm: 3001',})}
      }
      if (this.state.language === 'Chinese'){
        if (code === 'Creator'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or person who hires a service, buys, requests advice, among others ... and who pays ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Observer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Person who arbitrates or observes',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Authorizer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Person who represents a company, department or himself and who signs the document ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Support'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or person whose function is technical support and support in the installation of IoT devices',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Payer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Payment can be delegated to a company or private person ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'PayTo'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or Individual that provides service, sells, investigates, advises, among others ... and receives payment ',dialogTitle: 'Confirm: 3001',})}
      }
      if (this.state.language === 'German'){
        if (code === 'Creator'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or person who hires a service, buys, requests advice, among others ... and who pays ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Observer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Person who arbitrates or observes',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Authorizer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Person who represents a company, department or himself and who signs the document ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Support'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or person whose function is technical support and support in the installation of IoT devices',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Payer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Payment can be delegated to a company or private person ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'PayTo'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or Individual that provides service, sells, investigates, advises, among others ... and receives payment ',dialogTitle: 'Confirm: 3001',})}
      }
      if (this.state.language === 'Italian'){
        if (code === 'Creator'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or person who hires a service, buys, requests advice, among others ... and who pays ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Observer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Person who arbitrates or observes',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Authorizer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Person who represents a company, department or himself and who signs the document ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Support'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or person whose function is technical support and support in the installation of IoT devices',dialogTitle: 'Confirm: 3001',})}
        if (code === 'Payer'){this.setState({dialogOpenInfo: true,dialogMessage: 'Payment can be delegated to a company or private person ',dialogTitle: 'Confirm: 3001',})}
        if (code === 'PayTo'){this.setState({dialogOpenInfo: true,dialogMessage: 'Company or Individual that provides service, sells, investigates, advises, among others ... and receives payment ',dialogTitle: 'Confirm: 3001',})}
      }
    }

    goMasterFile() {
      this.setState({modifying: false})
      let typeMasterFile2 = ''
      if (this.c01MasterFile.current.value==='Concepts for Payment Forms'){
          this.setState({opcionMasterFile: 'Concepts for Payment Forms',typeMasterFile: 'concepts_payment_forms'})
          typeMasterFile2 = 'concepts_payment_forms'
      }else{
        if (this.c01MasterFile.current.value==='Industrial Maintenance (Associated to)'){
            this.setState({opcionMasterFile: 'Industrial Maintenance (Associated to)',typeMasterFile: 'maintenance_associatedof'})
            typeMasterFile2 = 'maintenance_associatedof'
        }else{
          if (this.c01MasterFile.current.value==='Category'){
              this.setState({opcionMasterFile: 'Device ID',typeMasterFile: 'sensor_category'})
              typeMasterFile2 = 'sensor_category'
          }else{
            if (this.c01MasterFile.current.value==='SensorId'){
                this.setState({opcionMasterFile: 'Sensor',typeMasterFile: 'sensor_id'})
                typeMasterFile2 = 'sensor_id'
            }else{
              if (this.c01MasterFile.current.value==='UnitMeasurementTemperature'){
                  this.setState({opcionMasterFile: 'Unit Measurement Temperature',typeMasterFile: 'unit_measurement_temperature'})
                  typeMasterFile2 = 'unit_measurement_temperature'
              }else{
                if (this.c01MasterFile.current.value==='UnitMeasurementHumidity'){
                    this.setState({opcionMasterFile: 'Unit Measurement Humidity',typeMasterFile: 'unit_measurement_humidity'})
                    typeMasterFile2 = 'unit_measurement_humidity'
                }else{
                  if (this.c01MasterFile.current.value==='UnitMeasurementGasControl'){
                      this.setState({opcionMasterFile: 'Unit Measurement Gas Control',typeMasterFile: 'unit_measurement_gascontrol'})
                      typeMasterFile2 = 'unit_measurement_gascontrol'
                  }else{
                    if (this.c01MasterFile.current.value==='UnitMeasurementGPS'){
                        this.setState({opcionMasterFile: 'Unit Measurement GPS',typeMasterFile: 'unit_measurement_gps'})
                        typeMasterFile2 = 'unit_measurement_gps'
                    }else{
                      if (this.c01MasterFile.current.value==='UnitFrecuency'){
                          this.setState({opcionMasterFile: 'Unit Frecuency',typeMasterFile: 'unit_frecuency'})
                          typeMasterFile2 = 'unit_frecuency'
                      }else{
                        if (this.c01MasterFile.current.value==='UnitTimeUnit'){
                            this.setState({opcionMasterFile: 'Unit TimeUnit',typeMasterFile: 'unit_time_unit'})
                            typeMasterFile2 = 'unit_time_unit'
                        }else{
                          if (this.c01MasterFile.current.value==='ErrorAction'){
                              this.setState({opcionMasterFile: 'Error Action',typeMasterFile: 'error_action'})
                              typeMasterFile2 = 'error_action'
                          }else{
                            if (this.c01MasterFile.current.value==='Client Work Order'){
                                this.setState({opcionMasterFile: 'Client Work Order',typeMasterFile: 'client_work_order'})
                                typeMasterFile2 = 'client_work_order'
                            }else{
                              if (this.c01MasterFile.current.value==='Business Pairs Contact'){
                                  this.setState({opcionMasterFile: 'Business Pairs Contact',typeMasterFile: 'userlist_remote'})
                                  typeMasterFile2 = 'userlist_remote'
                              }

                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      this.setState({jsonBlockstack: [],displayMasterFile: true})
      const {userSession} = this.state
      const storage = new Storage({ userSession });
      const options = { decrypt: false, verify: false }
      localStorage.removeItem('jsonBlockstack20')
      getFileDB(this.state.username, `${typeMasterFile2}.json`)
         .then((fileContents) => {
           if(fileContents) {
             const jsonBlockstack1 = JSON.parse(fileContents)
             const jsonBlockstack2 = jsonBlockstack1.data
             let jsonBlockstack5 = '[]'
             if (jsonBlockstack2 !== null){
                const jsonBlockstack3 = jsonBlockstack2.dataobject
                const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                if (jsonBlockstack4.substring(0,1) === '"') {
                   jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                } else {
                   jsonBlockstack5 = jsonBlockstack4
                }
             }
             let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
             localStorage.setItem('jsonBlockstack20',jsonBlockstack5)
             this.setState({jsonBlockstack: jsonBlockstack6})
           } else {}
         })
        .catch(error => {});
    }

    goMasterFileDeliverable = () => {
      this.setState({modifying: false, bEditRango: false, displayDiametroOcupadoKPI: false})
      let typeMasterFile2 = ''
      if (this.c01MasterFile.current.value==='Turno'){ this.setState({opcionMasterFile: 'Turno',typeMasterFile: 'turno'}); typeMasterFile2 = 'turno'}
      if (this.c01MasterFile.current.value==='Actividades'){ this.setState({opcionMasterFile: 'Actividades',typeMasterFile: 'actividades'}); typeMasterFile2 = 'actividades'}
      if (this.c01MasterFile.current.value==='Proposito'){ this.setState({opcionMasterFile: 'Proposito',typeMasterFile: 'proposito'}); typeMasterFile2 = 'proposito'}
      if (this.c01MasterFile.current.value==='Sector'){ this.setState({opcionMasterFile: 'Sector',typeMasterFile: 'sector'}); typeMasterFile2 = 'sector'}
      if (this.c01MasterFile.current.value==='EstadoPozo'){ this.setState({opcionMasterFile: 'EstadoPozo',typeMasterFile: 'estado_pozo'}); typeMasterFile2 = 'estado_pozo'}
      if (this.c01MasterFile.current.value==='PozoMonitoreo'){ this.setState({opcionMasterFile: 'PozoMonitoreo',typeMasterFile: 'pozo_monitoreo'}); typeMasterFile2 = 'pozo_monitoreo'}
      if (this.c01MasterFile.current.value==='TipoMuestra'){ this.setState({opcionMasterFile: 'TipoMuestra',typeMasterFile: 'tipo_muestra'}); typeMasterFile2 = 'tipo_muestra'}
      if (this.c01MasterFile.current.value==='EstadoSondaje'){ this.setState({opcionMasterFile: 'EstadoSondaje',typeMasterFile: 'estado_sondaje'}); typeMasterFile2 = 'estado_sondaje'}
      if (this.c01MasterFile.current.value==='Herramienta'){ this.setState({opcionMasterFile: 'Herramienta',typeMasterFile: 'herramienta'}); typeMasterFile2 = 'herramienta'}
      if (this.c01MasterFile.current.value==='TipoPerforacion'){ this.setState({opcionMasterFile: 'TipoPerforacion',typeMasterFile: 'tipo_perforacion'}); typeMasterFile2 = 'tipo_perforacion'}
      if (this.c01MasterFile.current.value==='Perforacion'){ this.setState({opcionMasterFile: 'Perforacion',typeMasterFile: 'perforacion'}); typeMasterFile2 = 'perforacion'}
      if (this.c01MasterFile.current.value==='Diametros'){ this.setState({opcionMasterFile: 'Diametros',typeMasterFile: 'diametros'}); typeMasterFile2 = 'diametros'}
      if (this.c01MasterFile.current.value==='Sobrecarga'){ this.setState({opcionMasterFile: 'Sobrecarga',typeMasterFile: 'sobrecarga'}); typeMasterFile2 = 'sobrecarga'}
      if (this.c01MasterFile.current.value==='SobrecargaNatural'){ this.setState({opcionMasterFile: 'SobrecargaNatural',typeMasterFile: 'sobrecarga_natural', bEditRango: true}); typeMasterFile2 = 'sobrecarga_natural'}
      if (this.c01MasterFile.current.value==='SobrecargaNoNatural'){ this.setState({opcionMasterFile: 'SobrecargaNoNatural',typeMasterFile: 'sobrecarga_no_natural', bEditRango: true}); typeMasterFile2 = 'sobrecarga_no_natural'}
      if (this.c01MasterFile.current.value==='Roca'){ this.setState({opcionMasterFile: 'Roca',typeMasterFile: 'roca'}); typeMasterFile2 = 'roca'}
      if (this.c01MasterFile.current.value==='RocaMuestraSeca'){ this.setState({opcionMasterFile: 'RocaMuestraSeca',typeMasterFile: 'roca_muestra_seca', bEditRango: true}); typeMasterFile2 = 'roca_muestra_seca'}
      if (this.c01MasterFile.current.value==='RocaMuestraHumeda'){ this.setState({opcionMasterFile: 'RocaMuestraHumeda',typeMasterFile: 'roca_muestra_humeda', bEditRango: true}); typeMasterFile2 = 'roca_muestra_humeda'}
      if (this.c01MasterFile.current.value==='RocaMuestraHumedaMartillo'){ this.setState({opcionMasterFile: 'RocaMuestraHumedaMartillo',typeMasterFile: 'roca_muestra_humeda_martillo', bEditRango: true}); typeMasterFile2 = 'roca_muestra_humeda_martillo'}

      this.setState({jsonBlockstack: [],displayMasterFile: true})
      const {userSession} = this.state
      const storage = new Storage({ userSession });
      const options = { decrypt: false, verify: false }
      localStorage.removeItem('jsonBlockstack20')
      getFileDB(this.state.username, `${typeMasterFile2}.json`)
         .then((fileContents) => {
           if(fileContents) {
             const jsonBlockstack1 = JSON.parse(fileContents)
             const jsonBlockstack2 = jsonBlockstack1.data
             let jsonBlockstack5 = '[]'
             if (jsonBlockstack2 !== null){
                const jsonBlockstack3 = jsonBlockstack2.dataobject
                const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                if (jsonBlockstack4.substring(0,1) === '"') {
                   jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                } else {
                   jsonBlockstack5 = jsonBlockstack4
                }
             }
             let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
             localStorage.setItem('jsonBlockstack20',jsonBlockstack5)
             this.setState({jsonBlockstack: jsonBlockstack6})
           } else {}
         })
        .catch(error => {});
    }

    goDetailRole() {
      const {userSession} = this.state
      const storage = new Storage({ userSession });
      const options = { decrypt: false, verify: false }
      let typeRole2 = 'role'
      this.setState({opcionRole: 'Role',typeRole: 'role',jsonBlockstack: [],displayRole: true})
      localStorage.removeItem('jsonBlockstack20')
      getFileDB(this.state.username, `${typeRole2}.json`)
         .then((fileContents) => {
           if(fileContents) {
             const jsonBlockstack1 = JSON.parse(fileContents)
             const jsonBlockstack2 = jsonBlockstack1.data
             let jsonBlockstack5 = '[]'
             if (jsonBlockstack2 !== null){
                const jsonBlockstack3 = jsonBlockstack2.dataobject
                const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                if (jsonBlockstack4.substring(0,1) === '"') {
                   jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                } else {
                   jsonBlockstack5 = jsonBlockstack4
                }
             }
             let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
             localStorage.setItem('jsonBlockstack20',jsonBlockstack5)
             this.setState({jsonBlockstack: jsonBlockstack6})
           } else {}
         })
        .catch(error => {});
    }

    goDetailSetting(usernameX) {
      const {userSession} = this.state
      const storage = new Storage({ userSession });
      const options = { decrypt: false, verify: false }
      this.setState({jsonBlockstackY: [],displaySetting: true})
      let settingEncryptDecryptFile = 'No'
        getFileDB(usernameX, `settings3.json`)
         .then((fileContents) => {
           if(fileContents) {
             const jsonBlockstack1 = JSON.parse(fileContents)
             const jsonBlockstack2 = jsonBlockstack1.data
             let jsonBlockstack5 = '[]'
             let jsonBlockstack8 = '[]'
             let jsonBlockstack10 = '[]'
             if (jsonBlockstack2 !== null){
                 const jsonBlockstack3 = jsonBlockstack2.dataobject
                 const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                 if (jsonBlockstack4.substring(0,1) === '"') {
                    jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                 } else {
                    jsonBlockstack5 = jsonBlockstack4
                 }

                 const jsonBlockstack6 = jsonBlockstack2.options
                 const jsonBlockstack7 = jsonBlockstack6.replace(/\\/g,"");
                 if (jsonBlockstack7.substring(0,1) === '"') {
                    jsonBlockstack8 = jsonBlockstack7.substring(1,jsonBlockstack7.length - 1)
                 } else {
                    jsonBlockstack8 = jsonBlockstack7
                 }
                 let jsonBlockstack9 = JSON.parse(jsonBlockstack8)

                 if (jsonBlockstack9.encrypt === true) {
                   Promise.all([profileUser(usernameX)])
                    .then(
                      (publicKey) =>{
                        const vi = jsonBlockstack5

                        const data = jsonBlockstack5,
                              iv = '1111111111111111',
                              password = publicKey

                        const key = forge.md.sha256.create().update(password).digest().getBytes();

                        const encryptedBytes = forge.util.decode64(data);
                        const decipher = forge.cipher.createDecipher('AES-CTR', key)
                        decipher.start({ iv });
                        decipher.update(forge.util.createBuffer(encryptedBytes));
                        decipher.finish();
                        const decryptedBytes = decipher.output.getBytes();
                        const decryptedString = forge.util.encodeUtf8(decryptedBytes);
                        let jsonBlockstack4 = decryptedString.replace(/\\/g,"");
                        if (jsonBlockstack4.substring(0,1) === '"') {
                           jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                        } else {
                           jsonBlockstack5 = jsonBlockstack4
                        }
                        jsonBlockstack10 = JSON.parse(jsonBlockstack5)
                        const largo = jsonBlockstack10.length
                        jsonBlockstack10.map((todo,i)=>{
                          if(todo.code==='EncryptDecryptFile'){
                            settingEncryptDecryptFile = todo.description
                          }
                          if (i === (largo - 1)){
                          }
                        })
                        this.setState({encryptDecryptFile: settingEncryptDecryptFile})
                        this.setState({jsonBlockstackY: jsonBlockstack10})
                      },
                      (reject) =>{}
                    )
                 }else{
                   jsonBlockstack10 = JSON.parse(jsonBlockstack5)
                   const largo = jsonBlockstack10.length
                   jsonBlockstack10.map((todo,i)=>{
                     if(todo.code==='EncryptDecryptFile'){
                       settingEncryptDecryptFile = todo.description
                     }
                     if (i === (largo - 1)){
                     }
                   })
                   this.setState({encryptDecryptFile: settingEncryptDecryptFile})
                   this.setState({jsonBlockstackY: jsonBlockstack10})
                 }
             }
           } else {}
         })
        .catch(error => {});
    }

    goDetailTag() {
      const {userSession} = this.state
      const storage = new Storage({ userSession });
      const options = { decrypt: false, verify: false }
      let typeRole2 = 'tag'
      this.setState({opcionRole: 'Tag',typeRole: 'tag',jsonBlockstack: [],displayTag: true})
      localStorage.removeItem('jsonBlockstack20')
      getFileDB(this.state.username, `tag.json`)
         .then((fileContents) => {
           if(fileContents) {
             const jsonBlockstack1 = JSON.parse(fileContents)
             const jsonBlockstack2 = jsonBlockstack1.data
             let jsonBlockstack5 = '[]'
             if (jsonBlockstack2 !== null){
                const jsonBlockstack3 = jsonBlockstack2.dataobject
                const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                if (jsonBlockstack4.substring(0,1) === '"') {
                   jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                } else {
                   jsonBlockstack5 = jsonBlockstack4
                }
             }
             let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
             localStorage.setItem('jsonBlockstack20',jsonBlockstack5)
             this.setState({jsonBlockstack: jsonBlockstack6})
           } else {}
         })
        .catch(error => {});
    }

    goSetting() {

      if (this.c01Setting.current.value==="DateFormat"){
        this.setState({modeSetting1: true,
                       modeSetting2: false,
                       modeSetting3: false,
                       modeSetting4: false,
                       modeSetting5: false,
                       modeSetting6: false,
                       modeSetting7: false,
                       modeSetting8: false,
                       modeSetting9: false,
                       modeSetting10: false,
                       modeSetting11: false,
                       modeSetting12: false,
                       modeSetting13: false,
                       modeSetting14: false,
                       modeSetting15: false,
                       modeSetting16: false,
                       modeSetting17: false,
                       modeSetting18: false,
                       modeSetting19: false,
                       modeSetting20: false})
      }else{
        if (this.c01Setting.current.value==="ShowTime"){
          this.setState({modeSetting1: false,
                         modeSetting2: true,
                         modeSetting3: false,
                         modeSetting4: false,
                         modeSetting5: false,
                         modeSetting6: false,
                         modeSetting7: false,
                         modeSetting8: false,
                         modeSetting9: false,
                         modeSetting10: false,
                         modeSetting11: false,
                         modeSetting12: false,
                         modeSetting13: false,
                         modeSetting14: false,
                         modeSetting15: false,
                         modeSetting16: false,
                         modeSetting17: false,
                         modeSetting18: false,
                         modeSetting19: false,
                         modeSetting20: false})
        }else{
          if (this.c01Setting.current.value==="PortsTime"){
            this.setState({modeSetting1: false,
                           modeSetting2: false,
                           modeSetting3: true,
                           modeSetting4: false,
                           modeSetting5: false,
                           modeSetting6: false,
                           modeSetting7: false,
                           modeSetting8: false,
                           modeSetting9: false,
                           modeSetting10: false,
                           modeSetting11: false,
                           modeSetting12: false,
                           modeSetting13: false,
                           modeSetting14: false,
                           modeSetting15: false,
                           modeSetting16: false,
                           modeSetting17: false,
                           modeSetting18: false,
                           modeSetting19: false,
                           modeSetting20: false})
          }else{
            if (this.c01Setting.current.value==="ViewDataSimulator"){
              this.setState({modeSetting1: false,
                             modeSetting2: false,
                             modeSetting3: false,
                             modeSetting4: true,
                             modeSetting5: false,
                             modeSetting6: false,
                             modeSetting7: false,
                             modeSetting8: false,
                             modeSetting9: false,
                             modeSetting10: false,
                             modeSetting11: false,
                             modeSetting12: false,
                             modeSetting13: false,
                             modeSetting14: false,
                             modeSetting15: false,
                             modeSetting16: false,
                             modeSetting17: false,
                             modeSetting18: false,
                             modeSetting19: false,
                             modeSetting20: false})
            }else{
              if (this.c01Setting.current.value==="StacksNetwork"){
                this.setState({modeSetting1: false,
                               modeSetting2: false,
                               modeSetting3: false,
                               modeSetting4: false,
                               modeSetting5: true,
                               modeSetting6: false,
                               modeSetting7: false,
                               modeSetting8: false,
                               modeSetting9: false,
                               modeSetting10: false,
                               modeSetting11: false,
                               modeSetting12: false,
                               modeSetting13: false,
                               modeSetting14: false,
                               modeSetting15: false,
                               modeSetting16: false,
                               modeSetting17: false,
                               modeSetting18: false,
                               modeSetting19: false,
                               modeSetting20: false})
              }else{
                if (this.c01Setting.current.value==="BringContractTemplateFrom"){
                  this.setState({modeSetting1: false,
                                 modeSetting2: false,
                                 modeSetting3: false,
                                 modeSetting4: false,
                                 modeSetting5: false,
                                 modeSetting6: true,
                                 modeSetting7: false,
                                 modeSetting8: false,
                                 modeSetting9: false,
                                 modeSetting10: false,
                                 modeSetting11: false,
                                 modeSetting12: false,
                                 modeSetting13: false,
                                 modeSetting14: false,
                                 modeSetting15: false,
                                 modeSetting16: false,
                                 modeSetting17: false,
                                 modeSetting18: false,
                                 modeSetting19: false,
                                 modeSetting20: false})
                }else{
                  if (this.c01Setting.current.value==="LanguageDisplay"){
                    this.setState({modeSetting1: false,
                                   modeSetting2: false,
                                   modeSetting3: false,
                                   modeSetting4: false,
                                   modeSetting5: false,
                                   modeSetting6: false,
                                   modeSetting7: true,
                                   modeSetting8: false,
                                   modeSetting9: false,
                                   modeSetting10: false,
                                   modeSetting11: false,
                                   modeSetting12: false,
                                   modeSetting13: false,
                                   modeSetting14: false,
                                   modeSetting15: false,
                                   modeSetting16: false,
                                   modeSetting17: false,
                                   modeSetting18: false,
                                   modeSetting19: false,
                                   modeSetting20: false})
                  }else{
                    if (this.c01Setting.current.value==="ColorTheme"){
                      this.setState({modeSetting1: false,
                                     modeSetting2: false,
                                     modeSetting3: false,
                                     modeSetting4: false,
                                     modeSetting5: false,
                                     modeSetting6: false,
                                     modeSetting7: false,
                                     modeSetting8: true,
                                     modeSetting9: false,
                                     modeSetting10: false,
                                     modeSetting11: false,
                                     modeSetting12: false,
                                     modeSetting13: false,
                                     modeSetting14: false,
                                     modeSetting15: false,
                                     modeSetting16: false,
                                     modeSetting17: false,
                                     modeSetting18: false,
                                     modeSetting19: false,
                                     modeSetting20: false})
                    }else{
                      if (this.c01Setting.current.value==="LanguageOrigin"){
                        this.setState({modeSetting1: false,
                                       modeSetting2: false,
                                       modeSetting3: false,
                                       modeSetting4: false,
                                       modeSetting5: false,
                                       modeSetting6: false,
                                       modeSetting7: false,
                                       modeSetting8: false,
                                       modeSetting9: true,
                                       modeSetting10: false,
                                       modeSetting11: false,
                                       modeSetting12: false,
                                       modeSetting13: false,
                                       modeSetting14: false,
                                       modeSetting15: false,
                                       modeSetting16: false,
                                       modeSetting17: false,
                                       modeSetting18: false,
                                       modeSetting19: false,
                                       modeSetting20: false})
                      }else{
                          if (this.c01Setting.current.value==="DisplayCompanyLogoData"){
                            this.setState({modeSetting1: false,
                                           modeSetting2: false,
                                           modeSetting3: false,
                                           modeSetting4: false,
                                           modeSetting5: false,
                                           modeSetting6: false,
                                           modeSetting7: false,
                                           modeSetting8: false,
                                           modeSetting9: false,
                                           modeSetting10: false,
                                           modeSetting11: true,
                                           modeSetting12: false,
                                           modeSetting13: false,
                                           modeSetting14: false,
                                           modeSetting15: false,
                                           modeSetting16: false,
                                           modeSetting17: false,
                                           modeSetting18: false,
                                           modeSetting19: false,
                                           modeSetting20: false})
                          }else{
                            if (this.c01Setting.current.value==="FIACurrency"){
                              this.setState({modeSetting1: false,
                                             modeSetting2: false,
                                             modeSetting3: false,
                                             modeSetting4: false,
                                             modeSetting5: false,
                                             modeSetting6: false,
                                             modeSetting7: false,
                                             modeSetting8: false,
                                             modeSetting9: false,
                                             modeSetting10: false,
                                             modeSetting11: false,
                                             modeSetting12: true,
                                             modeSetting13: false,
                                             modeSetting14: false,
                                             modeSetting15: false,
                                             modeSetting16: false,
                                             modeSetting17: false,
                                             modeSetting18: false,
                                             modeSetting19: false,
                                             modeSetting20: false})
                            }else{
                              if (this.c01Setting.current.value==="DocumentSidebarStartsOpen"){
                                this.setState({modeSetting1: false,
                                               modeSetting2: false,
                                               modeSetting3: false,
                                               modeSetting4: false,
                                               modeSetting5: false,
                                               modeSetting6: false,
                                               modeSetting7: false,
                                               modeSetting8: false,
                                               modeSetting9: false,
                                               modeSetting10: false,
                                               modeSetting11: false,
                                               modeSetting12: false,
                                               modeSetting13: true,
                                               modeSetting14: false,
                                               modeSetting15: false,
                                               modeSetting16: false,
                                               modeSetting17: false,
                                               modeSetting18: false,
                                               modeSetting19: false,
                                               modeSetting20: false})
                              }else{
                                 if (this.c01Setting.current.value==="CryptoCurrencyOrigin"){
                                   this.setState({modeSetting1: false,
                                                  modeSetting2: false,
                                                  modeSetting3: false,
                                                  modeSetting4: false,
                                                  modeSetting5: false,
                                                  modeSetting6: false,
                                                  modeSetting7: false,
                                                  modeSetting8: false,
                                                  modeSetting9: false,
                                                  modeSetting10: false,
                                                  modeSetting11: false,
                                                  modeSetting12: false,
                                                  modeSetting13: false,
                                                  modeSetting14: true,
                                                  modeSetting15: false,
                                                  modeSetting16: false,
                                                  modeSetting17: false,
                                                  modeSetting18: false,
                                                  modeSetting19: false,
                                                  modeSetting20: false})
                                 }else{
                                    if (this.c01Setting.current.value==="CryptoCurrency"){
                                      this.setState({modeSetting1: false,
                                                     modeSetting2: false,
                                                     modeSetting3: false,
                                                     modeSetting4: false,
                                                     modeSetting5: false,
                                                     modeSetting6: false,
                                                     modeSetting7: false,
                                                     modeSetting8: false,
                                                     modeSetting9: false,
                                                     modeSetting10: false,
                                                     modeSetting11: false,
                                                     modeSetting12: false,
                                                     modeSetting13: false,
                                                     modeSetting14: false,
                                                     modeSetting15: true,
                                                     modeSetting16: false,
                                                     modeSetting17: false,
                                                     modeSetting18: false,
                                                     modeSetting19: false,
                                                     modeSetting20: false})
                                    }else{
                                       if (this.c01Setting.current.value==="DisplayChat"){
                                         this.setState({modeSetting1: false,
                                                        modeSetting2: false,
                                                        modeSetting3: false,
                                                        modeSetting4: false,
                                                        modeSetting5: false,
                                                        modeSetting6: false,
                                                        modeSetting7: false,
                                                        modeSetting8: false,
                                                        modeSetting9: false,
                                                        modeSetting10: false,
                                                        modeSetting11: false,
                                                        modeSetting12: false,
                                                        modeSetting13: false,
                                                        modeSetting14: false,
                                                        modeSetting15: false,
                                                        modeSetting16: true,
                                                        modeSetting17: false,
                                                        modeSetting18: false,
                                                        modeSetting19: false,
                                                        modeSetting20: false})
                                      }else{
                                         if (this.c01Setting.current.value==="ProfileMode"){
                                           this.setState({modeSetting1: false,
                                                          modeSetting2: false,
                                                          modeSetting3: false,
                                                          modeSetting4: false,
                                                          modeSetting5: false,
                                                          modeSetting6: false,
                                                          modeSetting7: false,
                                                          modeSetting8: false,
                                                          modeSetting9: false,
                                                          modeSetting10: false,
                                                          modeSetting11: false,
                                                          modeSetting12: false,
                                                          modeSetting13: false,
                                                          modeSetting14: false,
                                                          modeSetting15: false,
                                                          modeSetting16: false,
                                                          modeSetting17: true,
                                                          modeSetting18: false,
                                                          modeSetting19: false,
                                                          modeSetting20: false})
                                         }else{
                                            if (this.c01Setting.current.value==="LandingPage"){
                                              this.setState({modeSetting1: false,
                                                             modeSetting2: false,
                                                             modeSetting3: false,
                                                             modeSetting4: false,
                                                             modeSetting5: false,
                                                             modeSetting6: false,
                                                             modeSetting7: false,
                                                             modeSetting8: false,
                                                             modeSetting9: false,
                                                             modeSetting10: false,
                                                             modeSetting11: false,
                                                             modeSetting12: false,
                                                             modeSetting13: false,
                                                             modeSetting14: false,
                                                             modeSetting15: false,
                                                             modeSetting16: false,
                                                             modeSetting17: false,
                                                             modeSetting18: true,
                                                             modeSetting19: false,
                                                             modeSetting20: false})
                                            }else{
                                               if (this.c01Setting.current.value==="DisabledInvitationFinances"){
                                                 this.setState({modeSetting1: false,
                                                                modeSetting2: false,
                                                                modeSetting3: false,
                                                                modeSetting4: false,
                                                                modeSetting5: false,
                                                                modeSetting6: false,
                                                                modeSetting7: false,
                                                                modeSetting8: false,
                                                                modeSetting9: false,
                                                                modeSetting10: false,
                                                                modeSetting11: false,
                                                                modeSetting12: false,
                                                                modeSetting13: false,
                                                                modeSetting14: false,
                                                                modeSetting15: false,
                                                                modeSetting16: false,
                                                                modeSetting17: false,
                                                                modeSetting18: false,
                                                                modeSetting19: true,
                                                                modeSetting20: false})
                                                }else{
                                                   if (this.c01Setting.current.value==="CompressedSidebar"){
                                                     this.setState({modeSetting1: false,
                                                                    modeSetting2: false,
                                                                    modeSetting3: false,
                                                                    modeSetting4: false,
                                                                    modeSetting5: false,
                                                                    modeSetting6: false,
                                                                    modeSetting7: false,
                                                                    modeSetting8: false,
                                                                    modeSetting9: false,
                                                                    modeSetting10: false,
                                                                    modeSetting11: false,
                                                                    modeSetting12: false,
                                                                    modeSetting13: false,
                                                                    modeSetting14: false,
                                                                    modeSetting15: false,
                                                                    modeSetting16: false,
                                                                    modeSetting17: false,
                                                                    modeSetting18: false,
                                                                    modeSetting19: false,
                                                                    modeSetting20: true})
                                                     }
                                                  }
                                              }
                                           }
                                         }
                                      }
                                   }
                                }
                             }
                          }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    goDetailContracts(){
      const {userSession} = this.state
      const storage = new Storage({ userSession });
      const options = { decrypt: false, verify: false }
      getFileDB(this.state.username, `contractdoc.json`)
         .then((fileContents) => {
           if(fileContents) {
             const jsonBlockstack1 = JSON.parse(fileContents)
             const jsonBlockstack2 = jsonBlockstack1.data
             let jsonBlockstack5 = '[]'
             if (jsonBlockstack2 !== null){
                const jsonBlockstack3 = jsonBlockstack2.dataobject
                const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                if (jsonBlockstack4.substring(0,1) === '"') {
                   jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                } else {
                   jsonBlockstack5 = jsonBlockstack4
                }
             }
             let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
             this.setState({templatesAllLocal: jsonBlockstack6})
           } else {}
         })
        .catch(error => {
          console.log(error)
        });
    }

    clickRemoveMasterFileDiametro = (e,optx, codex) => {
      const masterfile = this.state.jsonDiametroOcupado
      masterfile.splice(optx,1);
      this.setState({jsonDiametroOcupado: masterfile})
      const jsonBlockstack1 = JSON.stringify(masterfile)
      const {userSession} = this.state
      const storage = new Storage({ userSession });
      const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
      putFileDB(this.state.username, `diametro_ocupado_kpi.json`, 'Crosscheck_Setting', jsonBlockstack1, JSON.stringify(options))
        .then(() => {
        })
    }

    clickRemoveMasterFile = (e,optx, codex) => {
      if (this.state.typeMasterFile === 'sensor_id'){
        Promise.all(
           [this.verificateDevice(codex)]
        ).then(
          (resolve) =>{
                const masterfile = this.state.jsonBlockstack
                masterfile.splice(optx,1);
                this.setState({jsonBlockstack: masterfile})
                const jsonBlockstack1 = JSON.stringify(masterfile)
                const {userSession} = this.state
                const storage = new Storage({ userSession });
                const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
                putFileDB(this.state.username, `${this.state.typeMasterFile}.json`, 'Crosscheck_Setting', jsonBlockstack1, JSON.stringify(options))
                  .then(() => {
                     localStorage.setItem('jsonBlockstack20',jsonBlockstack1)
                  })
          },
          (reject) =>{
                this.deleteConfirm()
          }
        )
      }else{
        if (this.state.typeMasterFile === 'role'){
          Promise.all(
             [this.verificateContractList(codex)]
          ).then(
            (resolve) =>{
                  const masterfile = this.state.jsonBlockstack
                  masterfile.splice(optx,1);
                  this.setState({jsonBlockstack: masterfile})
                  const jsonBlockstack1 = JSON.stringify(masterfile)
                  const {userSession} = this.state
                  const storage = new Storage({ userSession });
                  const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
                  putFileDB(this.state.username, `${this.state.typeMasterFile}.json`, 'Crosscheck_Setting', jsonBlockstack1, JSON.stringify(options))
                    .then(() => {
                       localStorage.setItem('jsonBlockstack20',jsonBlockstack1)
                    })
            },
            (reject) =>{
                  this.deleteConfirmRole()
            }
          )
          }else{
            if (this.state.typeMasterFile === 'sensor_category'){
              Promise.all(
                 [this.verificateSensor(codex)]
              ).then(
                (resolve) =>{
                      const masterfile = this.state.jsonBlockstack
                      masterfile.splice(optx,1);
                      this.setState({jsonBlockstack: masterfile})
                      const jsonBlockstack1 = JSON.stringify(masterfile)
                      const {userSession} = this.state
                      const storage = new Storage({ userSession });
                      const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
                      putFileDB(this.state.username, `${this.state.typeMasterFile}.json`, 'Crosscheck_Setting', jsonBlockstack1, JSON.stringify(options))
                        .then(() => {
                           localStorage.setItem('jsonBlockstack20',jsonBlockstack1)
                        })
                },
                (reject) =>{
                      this.deleteConfirmDevice()
                }
              )
            }else{
                  const masterfile = this.state.jsonBlockstack
                  masterfile.splice(optx,1);
                  this.setState({jsonBlockstack: masterfile})
                  const jsonBlockstack1 = JSON.stringify(masterfile)
                  const {userSession} = this.state
                  const storage = new Storage({ userSession });
                  const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
                  putFileDB(this.state.username, `${this.state.typeMasterFile}.json`, 'Crosscheck_Setting', jsonBlockstack1, JSON.stringify(options))
                    .then(() => {
                       localStorage.setItem('jsonBlockstack20',jsonBlockstack1)
                    })
            }
          }
        }
        this.setState({modifying: false})
    }

    verificateContractList(codex){
      const {userSession} = this.state
      const storage = new Storage({ userSession });
      const options = { decrypt: false, verify: false }
      return new Promise ((resolve, reject) =>{
          getFileDB(this.state.username, `contractlist.json`)
             .then((fileContents) => {
               if(fileContents) {
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                 }
                 let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                 const largo = jsonBlockstack6.length
                 jsonBlockstack6.map((todo,i)=>{
                   Promise.all(
                      [this.verificateUserGroupRole(todo.typeContract,todo.configurationContractNumber,codex)]
                   ).then(
                     (resolve2) =>{
                       if (i === largo-1){
                            resolve()
                       }
                     },
                     (reject2) =>{
                       reject()
                     }
                   )
                 })
               } else {
                   resolve()
               }
             })
              .catch(error => {
                 resolve()
             });
        })
    }

    verificateUserGroupRole(typeContract,configurationContractNumber,codex){
      const {userSession} = this.state
      const storage = new Storage({ userSession });
      const options = { decrypt: false, verify: false }
      return new Promise ((resolve2, reject2) =>{
          getFileDB(this.state.username, `${typeContract}_${configurationContractNumber}_usergroup.json`)
             .then((fileContents) => {
               if(fileContents) {
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                 }
                 let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                 const largo = jsonBlockstack6.length
                 jsonBlockstack6.map((todo,i)=>{
                   if(todo.role === codex){
                     reject2()
                   }
                   if (i===largo-1){
                     resolve2()
                   }
                 })
               } else {
                   resolve2()
               }
             })
              .catch(error => {
                 resolve2()
             });
      })
    }

    verificateDevice(codex){
      const {userSession} = this.state
      const storage = new Storage({ userSession });
      const options = { decrypt: false, verify: false }
      return new Promise ((resolve, reject) =>{
          getFileDB(this.state.username, `sensor_category.json`)
             .then((fileContents) => {
               if(fileContents) {
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                 }
                 let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                 const largo = jsonBlockstack6.length
                 jsonBlockstack6.map((todo,i)=>{
                   Promise.all(
                      [this.verificateDeviceSensor(todo.code,codex)]
                   ).then(
                     (resolve2) =>{
                       if (i === largo-1){
                            resolve()
                       }
                     },
                     (reject2) =>{
                       reject()
                     }
                   )
                 })
               } else {
                   resolve()
               }
             })
              .catch(error => {
                 resolve()
             });
        })
    }

    verificateDeviceSensor(idx,codex){
      const {userSession} = this.state
      const storage = new Storage({ userSession });
      const options = { decrypt: false, verify: false }
      return new Promise ((resolve2, reject2) =>{
          getFileDB(this.state.username, `device_${idx}_sensor.json`)
             .then((fileContents) => {
               if(fileContents) {
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                 }
                 let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                 const largo = jsonBlockstack6.length
                 jsonBlockstack6.map((todo,i)=>{
                   if(todo.code === codex){
                     reject2()
                   }
                   if (i===largo-1){
                     resolve2()
                   }
                 })
               } else {
                   resolve2()
               }
             })
              .catch(error => {
                 resolve2()
             });
      })
    }

    verificateSensor(codex){
      const {userSession} = this.state
      const storage = new Storage({ userSession });
      const options = { decrypt: false, verify: false }
      return new Promise ((resolve, reject) =>{
          getFileDB(this.state.username, `device_${codex}_sensor.json`)
             .then((fileContents) => {
               if(fileContents) {
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                 }
                 let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                 if (jsonBlockstack5==="[]"){
                    resolve()
                 }else{
                    reject()
                 }
               } else {
                   resolve()
               }
             })
              .catch(error => {
                 resolve()
             });
        })
    }

    crearMasterFile = (infoMasterFile, modeX) => {
      if (modeX === 1){
        this.setState({jsonBlockstack: JSON.parse(infoMasterFile),
                       code: '',
                       description: '',
                       modifying: false,
                       jsonRol: {}})
        localStorage.setItem('jsonBlockstack20',infoMasterFile)
      }
      if (modeX === 2){
        this.setState({jsonDiametroOcupado:infoMasterFile,
                       code: '',
                       description: '',
                       modifying: false})
      }
      if (modeX === 3){
        this.setState({jsonBlockstack:infoMasterFile,
                       displayDiametroOcupadoKPI: false,
                       displayMasterFile: true})
      }
    }

    clickEditMasterFileDiametro = (e,optx) => {
      const {jsonDiametroOcupado} = this.state
      const {code} = jsonDiametroOcupado[optx]
      const {description} = jsonDiametroOcupado[optx]
      this.setState({
          code: code,
          description: description,
          modifying: true,
      })
    }

    clickEditMasterUserlistRemote = (e,optx) => {
      const {jsonBlockstack} = this.state
      const {remoteuser} = jsonBlockstack[optx]
      const {active} = jsonBlockstack[optx]
      this.setState({
          remoteUserX: remoteuser,
          activeRemoteUserX: active,
          modifying: true,
      })
    }

    clickEditMasterFile = (e,optx) => {
        const {jsonBlockstack} = this.state
        const {code} = jsonBlockstack[optx]
        const {description} = jsonBlockstack[optx]
        this.setState({
            code: code,
            description: description,
            modifying: true,
        })
        if (this.state.selectedConfiguration === "Tag"){
          const {colorletter} = jsonBlockstack[optx]
          const {hex} = jsonBlockstack[optx]
          this.setState({colorletter, hex })
        }
        if (this.state.selectedConfiguration === "Role"){
          /*
          const {usergroup} = jsonBlockstack[optx]
          const {sign} = jsonBlockstack[optx]
          const {wallet} = jsonBlockstack[optx]
          const {blockchain} = jsonBlockstack[optx]
          const {linkdevice} = jsonBlockstack[optx]
          const {dashboard} = jsonBlockstack[optx]
          const {chat} = jsonBlockstack[optx]
          const {pay} = jsonBlockstack[optx]
          const {attachments} = jsonBlockstack[optx]
          const {deliverables} = jsonBlockstack[optx]
          const {share} = jsonBlockstack[optx]
          const {document} = jsonBlockstack[optx]
          */
          const {paymentform} = jsonBlockstack[optx]
          const {participants} = jsonBlockstack[optx]
          const {pay} = jsonBlockstack[optx]
          const {certification} = jsonBlockstack[optx]
          const {trace} = jsonBlockstack[optx]
          const {deliverable} = jsonBlockstack[optx]
          const {network} = jsonBlockstack[optx]
          const {addons} = jsonBlockstack[optx]
          const {certificates} = jsonBlockstack[optx]

          this.setState({
            jsonRol: {"paymentform":paymentform,"participants":participants,"pay":pay,"certification":certification,"trace":trace,"deliverable":deliverable,"network":network,"addons":addons,"certificates":certificates}
            //jsonRol: {"usergroup":usergroup,"sign":sign,"wallet":wallet,"blockchain":blockchain,"linkdevice":linkdevice,"dashboard":dashboard,"chat":chat,"pay":pay,"attachments":attachments,"deliverables":deliverables,"share":share,"document":document}
          })
        }
    }

    clickRemoveSetting = (e,optx) => {
        const setting = this.state.jsonBlockstackY
        setting.splice(optx,1);
        this.setState({jsonBlockstackY: setting})
        let jsonBlockstack1 = JSON.stringify(setting)
        const {userSession} = this.state
        const storage = new Storage({ userSession });
        let options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
        Promise.all([profileUser(this.state.username)])
         .then(
           (resolve) =>{
               const data = jsonBlockstack1,
                     iv = '1111111111111111',
                     password = resolve
               const key = forge.md.sha256.create().update(password).digest().getBytes();
               const cipher = forge.cipher.createCipher('AES-CTR', key);
               cipher.start({ iv });
               cipher.update(forge.util.createBuffer(data));
               cipher.finish();
               const encryptedBytes = cipher.output.getBytes();
               const encryptedBase64 = forge.util.encode64(encryptedBytes);
               options = {contentType: 'application/json', encrypt: true, dangerouslyIgnoreEtag: true }
               jsonBlockstack1 = encryptedBase64
               putFileDB(this.state.username, `settings3.json`, 'Crosscheck_Setting', jsonBlockstack1, JSON.stringify(options))
                 .then(() => {
                    localStorage.setItem('jsonBlockstack50',jsonBlockstack1)
                 })
             },
           (reject) =>{
               putFileDB(this.state.username, `settings3.json`, 'Crosscheck_Setting', jsonBlockstack1, JSON.stringify(options))
                 .then(() => {
                    localStorage.setItem('jsonBlockstack50',jsonBlockstack1)
                 })
             }
         )
    }

    clickOther = (e,idx, namex, titlex, priorityx, taxx, file, secondaryName, paymentform, participants, pay, trace, deliverable, network, addons, activarparticipants, certificarfirma, activarentregable, certificarreglas) => {
      this.setState({displayOther: true,
                     nameOther: namex,
                     titleOther: titlex,
                     priorityOther: priorityx,
                     taxOther: taxx,
                     file: file,
                     idx: idx,
                     secondaryName: secondaryName,
                     paymentform: paymentform,
                     participants: participants,
                     pay:pay,
                     trace:trace,
                     deliverable:deliverable,
                     network:network,
                     addons:addons,
                     activarparticipants:activarparticipants,
                     certificarfirma:certificarfirma,
                     activarentregable:activarentregable,
                     certificarreglas:certificarreglas})
    }

    newSetting = (infoSetting) => {
      if (this.c01Setting.current.value === 'BringContractTemplateFrom'){
        if (this.c02Setting.current.value === 'Server'){
           localStorage.setItem('infoSetting',infoSetting)
           this.serverConfirm()
        }else{
           this.saveSetting(infoSetting,false)
        }
      }else{
        if (this.c01Setting.current.value === 'LanguageOrigin'){
           localStorage.setItem('languageOrigin',this.c02Setting.current.value)
           this.saveSetting(infoSetting,false)
        }else{
          if (this.c01Setting.current.value === 'CryptoCurrency'){
             localStorage.setItem('languageCryptocurrency',this.c02Setting.current.value)
             this.saveSetting(infoSetting,false)
             localStorage.setItem('cryptoCurrency',this.c02Setting.current.value)
             this.saveSetting(infoSetting,false)
          }else{
            if (this.c01Setting.current.value === 'StacksNetwork'){
               localStorage.setItem('serverStacks',this.c02Setting.current.value)
               this.saveSetting(infoSetting,false)
            }else{
              if (this.c01Setting.current.value === 'ColorTheme'){
                 localStorage.setItem('colorTheme',this.c02Setting.current.value)
                 this.saveSetting(infoSetting,true)
              }else{
                if (this.c01Setting.current.value === 'LandingPage'){
                   localStorage.setItem('landingPage',this.c02Setting.current.value)
                   this.saveSetting(infoSetting,true)
                }else{
                  if (this.c01Setting.current.value === 'DisabledInvitationFinances'){
                    localStorage.setItem('disabledInvitationFinances',this.c02Setting.current.value)
                    this.saveSetting(infoSetting,true)
                  }else{
                    if (this.c01Setting.current.value === 'CompressedSidebar'){
                      localStorage.setItem('compressedSidebar',this.c02Setting.current.value)
                      this.saveSetting(infoSetting,true)
                    }else{
                      this.saveSetting(infoSetting,false)
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

    resetSetting(){
          const setting = `[{"code":"StacksNetwork","concept":"Stacks Network (MainNet / TestNet)","description":"MainNet"},{"code":"CryptoCurrencyOrigin","concept":"Preferred Crypto Currency of Origin","description":"BTC - Bitcoin"},{"code":"CryptoCurrency","concept":"Crypto Currency Payment","description":"STX - Stacks"},{"code":"FIACurrency","concept":"Preferred FIAT Currency of Origin","description":"USD - US Dollar"},{"code":"LanguageDisplay","concept":"Language Display (ISO Code / Flag)","description":"ISO Code"},{"code":"LanguageOrigin","concept":"Language Origin (From Browser / For Configuration)","description":"From Browser"},{"code":"ColorTheme","concept":"Color Theme (Blue / Green / Grey / Dark)","description":"Dark"},{"code":"DisplayCompanyLogoData","concept":"Display Company Logo Data in Documents (Yes / No)","description":"Yes"},{"code":"ViewDataSimulator","concept":"View Data Simulator (Yes / No)","description":"No"},{"code":"ProfileMode","concept":"Profile Mode (Simple / Full)","description":"Simple"},{"code":"DateFormat","concept":"Date Format (yyyy-mm-dd / mm-dd-yyyy / dd-mm-yyyy)","description":"dd-mm-yyyy"},{"code":"PortsTime","concept":"Ports Time (My Local Time / Cordinated Universal Time)","description":"UTC-Cordinated Universal Time"},{"code":"ShowTime","concept":"Show Time (My Local Time / Ports Local Time / Cordinated Universal Time)","description":"MT-My Local Time"},{"code":"BringContractTemplateFrom","concept":"Bring Contract Template From (Server / Local)","description":"Local"},{"code":"DocumentSidebarStartsOpen","concept":"Document Sidebar Starts Open (Yes / No)","description":"Yes"},{"code":"EncryptDecryptFile","concept":"Encrypt Decrypt File (Yes / No)","description":"Yes"},{"code":"DisplayChat","concept":"Display Chat when editing Document (Yes / No)","description":"No"},{"code":"LandingPage","concept":"Include Landing Page (Yes / No)","description":"Yes"},{"code":"DisabledInvitationFinances","concept":"Disabled Menu 'My Invitations' and 'My Finances' (Yes / No)","description":"No"},{"code":"CompressedSidebar","concept":"Compressed Sidebar (Yes / No)","description":"No"}]`
          const {userSession} = this.state
          const storage = new Storage({ userSession });
          let options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
          let jsonBlockstack1 = JSON.stringify(setting)
          localStorage.setItem('colorTheme','Dark')
          localStorage.setItem('languageCryptocurrency','Stacks (STX)')
          localStorage.setItem('cryptoCurrency','Stacks (STX)')
          localStorage.setItem('serverStacks','MainNet')
          localStorage.setItem('languageOrigin','From Browser')
          localStorage.setItem('landingPage','Yes')
          localStorage.setItem('disabledInvitationFinances','No')
          localStorage.setItem('compressedSidebar','No')

          Promise.all([profileUser(this.state.username)])
           .then(
             (resolve) =>{
                 const data = jsonBlockstack1,
                       iv = '1111111111111111',
                       password = resolve
                 const key = forge.md.sha256.create().update(password).digest().getBytes();
                 const cipher = forge.cipher.createCipher('AES-CTR', key);
                 cipher.start({ iv });
                 cipher.update(forge.util.createBuffer(data));
                 cipher.finish();
                 const encryptedBytes = cipher.output.getBytes();
                 const encryptedBase64 = forge.util.encode64(encryptedBytes);
                 console.log("not encrypted: " + jsonBlockstack1);
                 console.log("encrypted: " + encryptedBase64);
                 options = {contentType: 'application/json', encrypt: true, dangerouslyIgnoreEtag: true }
                 jsonBlockstack1 = encryptedBase64
                 putFileDB(this.state.username, `settings3.json`, 'Crosscheck_Setting', jsonBlockstack1, JSON.stringify(options))
                   .then(() => {
                     this.goDetailSetting(this.state.username)
                 })
               },
             (reject) =>{
                 putFileDB(this.state.username, `settings3.json`, 'Crosscheck_Setting', jsonBlockstack1, JSON.stringify(options))
                   .then(() => {
                     this.goDetailSetting(this.state.username)
                 })
               }
          )
    }

    saveSetting(infoSetting,reinicia){
      const idxSetting = this.c01Setting.current.value
      const descriptionSetting = this.c02Setting.current.value;
      let infoSetting2 = ''
      let reviewSetting =JSON.stringify(this.state.jsonBlockstackY)
      const jsonBlockstack3 = reviewSetting.substring(1,reviewSetting.length - 1)
      let existNewSetting3 = false
      const infoSettingJSON = JSON.parse(reviewSetting)
      infoSettingJSON.map((todo, i) => {
         if (todo.code === idxSetting) {
            todo.description = descriptionSetting
            existNewSetting3 = true
            this.setState({existSetting: true})
            return(true)
         }
         return false
      })
      if (existNewSetting3===true){
          infoSetting2 = JSON.stringify(infoSettingJSON)
      }else{
          if (this.state.jsonBlockstackY.length===0 || jsonBlockstack3 === ''){
            infoSetting2 =`[{"code":"${idxSetting}","concept":"","description":"${descriptionSetting}"}]`
          }else{
            infoSetting2 =`[${jsonBlockstack3},{"code":"${idxSetting}","concept":"","description":"${descriptionSetting}"}]`
          }
      }
      const {userSession} = this.state
      const storage = new Storage({ userSession });
      let options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
      let jsonBlockstack1 = JSON.stringify(infoSetting2)

      Promise.all([profileUser(this.state.username)])
       .then(
         (resolve) =>{
             const data = jsonBlockstack1,
                   iv = '1111111111111111',
                   password = resolve
             const key = forge.md.sha256.create().update(password).digest().getBytes();
             const cipher = forge.cipher.createCipher('AES-CTR', key);
             cipher.start({ iv });
             cipher.update(forge.util.createBuffer(data));
             cipher.finish();
             const encryptedBytes = cipher.output.getBytes();
             const encryptedBase64 = forge.util.encode64(encryptedBytes);
             options = {contentType: 'application/json', encrypt: true, dangerouslyIgnoreEtag: true }
             jsonBlockstack1 = encryptedBase64
             putFileDB(this.state.username, `settings3.json`, 'Crosscheck_Setting', jsonBlockstack1, JSON.stringify(options))
               .then(() => {
                 if (reinicia){
                   this.setState({jsonBlockstackY: JSON.parse(infoSetting2)})
                   window.location = '/'
                 }
               })
             this.setState({jsonBlockstackY: JSON.parse(infoSetting2)})
           },
         (reject) =>{
             putFileDB(this.state.username, `settings3.json`, 'Crosscheck_Setting', jsonBlockstack1, JSON.stringify(options))
               .then(() => {
                 if (reinicia){
                   this.setState({jsonBlockstackY: JSON.parse(infoSetting2)})
                   window.location = '/'
                 }
               })
             this.setState({jsonBlockstackY: JSON.parse(infoSetting2)})
           }
         )

    }

    clickEditSetting = (e,optx) => {
    }


    goDetailIoTDevice() {
      const {userSession} = this.state
      const storage = new Storage({ userSession });
      const options = { decrypt: false, verify: false }
      this.setState({jsonBlockstack: [], displayIoTDevice: true})
      localStorage.removeItem('jsonBlockstack30')
      getFileDB(this.state.username, `sensor_category.json`)
         .then((fileContents) => {
           if(fileContents) {
             const jsonBlockstack1 = JSON.parse(fileContents)
             const jsonBlockstack2 = jsonBlockstack1.data
             let jsonBlockstack5 = '[]'
             if (jsonBlockstack2 !== null){
                const jsonBlockstack3 = jsonBlockstack2.dataobject
                const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                if (jsonBlockstack4.substring(0,1) === '"') {
                   jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                } else {
                   jsonBlockstack5 = jsonBlockstack4
                }
             }
             let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
             this.setState({jsonBlockstack: jsonBlockstack6})
           } else {}
         })
        .catch(error => {})
    }

    goIoTDevice() {
      const {userSession} = this.state
      const storage = new Storage({ userSession });
      const options = { decrypt: false, verify: false }
      const palabra = this.c01IoTDevice.current.value
      const ArrayIdValue = palabra.split(' - ')
      const idx = ArrayIdValue[0]
      this.setState({idx: idx,
                     jsonBlockstackZ: [],
                     displayIoTDevice: true})
      localStorage.removeItem('jsonBlockstack30')
      getFileDB(this.state.username, `device_${idx}_sensor.json`)
         .then((fileContents) => {
           if(fileContents) {
             const jsonBlockstack1 = JSON.parse(fileContents)
             const jsonBlockstack2 = jsonBlockstack1.data
             let jsonBlockstack5 = '[]'
             if (jsonBlockstack2 !== null){
                const jsonBlockstack3 = jsonBlockstack2.dataobject
                const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                if (jsonBlockstack4.substring(0,1) === '"') {
                   jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                } else {
                   jsonBlockstack5 = jsonBlockstack4
                }
             }
             let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
             localStorage.setItem('jsonBlockstack30',jsonBlockstack5)
             this.setState({jsonBlockstackZ: jsonBlockstack6, displayIoTDevice2: true})
           } else {}
         })
        .catch(error => {});
    }

    clickRemoveIoTDevice = (e,optx) => {
      Promise.all(
         [this.verificateContractList_2(optx)]
      ).then(
        (resolve) =>{
          const iotdevice = this.state.jsonBlockstackZ
          iotdevice.splice(optx,1);
          this.setState({jsonBlockstackZ: iotdevice})
          const jsonBlockstack1 = JSON.stringify(iotdevice)
          const {userSession} = this.state
          const storage = new Storage({ userSession });
          const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
          putFileDB(this.state.username, `device_${this.state.idx}_sensor.json`, 'Crosscheck,_Setting', jsonBlockstack1, JSON.stringify(options))
            .then(() => {
               localStorage.setItem('jsonBlockstack30',jsonBlockstack1)
            })
        },
        (reject) =>{
              this.deleteConfirmDeviceContract()
        }
      )
    }

    verificateContractList_2(codex){
      const {userSession} = this.state
      const storage = new Storage({ userSession });
      const options = { decrypt: false, verify: false }
      return new Promise ((resolve, reject) =>{
          getFileDB(this.state.username, `contractlist.json`)
             .then((fileContents) => {
               if(fileContents) {
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                 }
                 let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                 const largo = jsonBlockstack6.length
                 jsonBlockstack6.map((todo,i)=>{
                   Promise.all(
                      [this.verificateRules(todo.typeContract,todo.configurationContractNumber,codex)]
                   ).then(
                     (resolve2) =>{
                       if (i === largo-1){
                            resolve()
                       }
                     },
                     (reject2) =>{
                       reject()
                     }
                   )
                 })
               } else {
                   resolve()
               }
             })
              .catch(error => {
                 resolve()
             });
        })
    }

    verificateRules(typeContract,configurationContractNumber,codex){
      const {userSession} = this.state
      const storage = new Storage({ userSession });
      const options = { decrypt: false, verify: false }
      return new Promise ((resolve2, reject2) =>{
          getFileDB(`${typeContract}_${configurationContractNumber}_rules.json`, options)
             .then((fileContents) => {
               if(fileContents) {
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                 }
                 let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                 const largo = jsonBlockstack6.length
                 jsonBlockstack6.map((todo,i)=>{
                   Promise.all(
                      [this.verificateRulesDevice(typeContract,configurationContractNumber,todo.enrollment,codex)]
                   ).then(
                     (resolve3) =>{
                       if (i === largo-1){
                          resolve2()
                       }
                     },
                     (reject3) =>{
                       reject2()
                     }
                   )
                 })
               } else {
                   resolve2()
               }
             })
              .catch(error => {
                 resolve2()
             });
      })
    }

    verificateRulesDevice(typeContract,configurationContractNumber,enrollment,codex){
      const {userSession} = this.state
      const storage = new Storage({ userSession });
      const options = { decrypt: false, verify: false }
      return new Promise ((resolve3, reject3) =>{
          getFileDB(`${typeContract}_${configurationContractNumber}_${enrollment}_device.json`, options)
             .then((fileContents) => {
               if(fileContents) {
                 const jsonBlockstack1 = JSON.parse(fileContents)
                 const jsonBlockstack2 = jsonBlockstack1.data
                 let jsonBlockstack5 = '[]'
                 if (jsonBlockstack2 !== null){
                    const jsonBlockstack3 = jsonBlockstack2.dataobject
                    const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                    if (jsonBlockstack4.substring(0,1) === '"') {
                       jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                    } else {
                       jsonBlockstack5 = jsonBlockstack4
                    }
                 }
                 let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                 if (jsonBlockstack5 === "[]"){
                   resolve3()
                 }else{
                   resolve3()
                 }
               }else{
                   reject3()
               }
             })
              .catch(error => {
                 resolve3()
             });
      })
    }

    crearIoTDevice = (infoIoTDevice) => {
      this.setState({jsonBlockstackZ: JSON.parse(infoIoTDevice), displayIoTDevice2: true})
      localStorage.setItem('jsonBlockstack30',infoIoTDevice)
    }

    clickEditIoTDevice(){
    }

    clickUpdateContracts = (e,optx) => {
        const {templatesAllLocal} = this.state
        templatesAllLocal.map((todo2, y) => {
          if (y === optx) {
            todo2.title = this.cTitleContract.current.value
            const {userSession} = this.state
            const storage = new Storage({ userSession });
            const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
            putFileDB(this.state.username, `contractdoc.json`, 'Crosscheck,_Setting', JSON.stringify(templatesAllLocal), JSON.stringify(options))
              .then(() => {})
          }
        })
    }

    returnOther = (e) => {
      this.setState({displayOther: false})
    }

    sendOther = (e,titlex,priorityx,taxx,file,idX,paymentform,participants,pay,trace,deliverable,network,addons,activarparticipants,certificarfirma,activarentregable,certificarreglas) => {
      this.setState({displayOther: false})

      /*
      if (paymentform === undefined){  paymentform = true }
      if (participants === undefined){  participants = true }
      if (pay === undefined){  pay = true }
      if (trace === undefined){  trace = true }
      if (deliverable === undefined){  deliverable = true }
      if (network === undefined){  network = true }
      if (addons === undefined){  addons = true }

      if (activarparticipants === undefined){  activarparticipants = true }
      if (certificarfirma === undefined){  certificarfirma = true }
      if (activarentregable === undefined){  activarentregable = true }
      if (certificarreglas === undefined){  certificarreglas = true }
      */

      paymentform=this.state.paymentform
      participants=this.state.participants
      pay=this.state.pay
      trace=this.state.trace
      deliverable=this.state.deliverable
      network=this.state.network
      addons=this.state.addons

      activarparticipants=this.state.activarparticipants
      certificarfirma=this.state.certificarfirma
      activarentregable=this.state.activarentregable
      certificarreglas=this.state.certificarreglas

      const {templatesAllLocal} = this.state
      templatesAllLocal.map((todo2, j) => {
        if(j === idX){
          todo2.title=titlex
          todo2.priority=priorityx
          todo2.tax=taxx
          todo2.file=file
          todo2.paymentform=paymentform
          todo2.participants=participants
          todo2.pay=pay
          todo2.trace=trace
          todo2.deliverable=deliverable
          todo2.network=network
          todo2.addons=addons
          todo2.activarparticipants=activarparticipants
          todo2.certificarfirma=certificarfirma
          todo2.activarentregable=activarentregable
          todo2.certificarreglas=certificarreglas
          const jsonBlockstack1 = JSON.stringify(templatesAllLocal)
          const {userSession} = this.state
          const storage = new Storage({ userSession });
          const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
          putFileDB(this.state.username, `contractdoc.json`, 'Crosscheck,_Setting', jsonBlockstack1, JSON.stringify(options))
          .then(() => {})
          .catch(error => {
            console.log(error)
          });
        }
      })
    }

    deleteOther = (idX) => {
      this.setState({displayOther: false})
      const {templatesAllLocal} = this.state
      templatesAllLocal.map((todo2, j) => {
        if(j === idX){
          todo2.title=''
          todo2.priority=''
          todo2.tax=''
          todo2.file=''
          const jsonBlockstack1 = JSON.stringify(templatesAllLocal)
          const {userSession} = this.state
          const storage = new Storage({ userSession });
          const options = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
          putFileDB(this.state.username, `contractdoc.json`, 'Crosscheck,_Setting', jsonBlockstack1, JSON.stringify(options))
            .then(() => {})
        }
      })
    }

    diametroOcupadoKPI = (e,codeX, descriptionX) => {
      this.setState({displayDiametroOcupadoKPI:true, displayMasterFile:false})
      this.setState({codeDiametroOcupado: codeX})
      this.setState({descriptionDiametroOcupado: descriptionX})
      this.setState({jsonDiametroOcupado: []})
      const {userSession} = this.state
      const storage = new Storage({ userSession });
      const options = { decrypt: false, verify: false }
      getFileDB(this.state.username, `diametro_ocupado_kpi.json`)
         .then((fileContents) => {
           if(fileContents) {
             const jsonBlockstack1 = JSON.parse(fileContents)
             const jsonBlockstack2 = jsonBlockstack1.data
             let jsonBlockstack5 = '[]'
             if (jsonBlockstack2 !== null){
                const jsonBlockstack3 = jsonBlockstack2.dataobject
                const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                if (jsonBlockstack4.substring(0,1) === '"') {
                   jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                } else {
                   jsonBlockstack5 = jsonBlockstack4
                }
             }
             let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
             this.setState({jsonDiametroOcupado: jsonBlockstack6})
             this.setState({codeDiametroOcupado: codeX})
             this.setState({descriptionDiametroOcupado: descriptionX})
           } else {}
         })
        .catch(error => {});
    }

    clickDownload = (e) => {
      e.preventDefault();
      //triggerBase64Download(this.state.jsonBackupRestore, 'backup_crosscheck.json')
      //const filedecodeAttachX = Base64.encode(this.state.jsonBackupRestore);

      const jsonString = `data:text/json;chatset=utf-8,${encodeURIComponent(
          JSON.stringify(this.state.jsonBackupRestore)
        )}`;
      const link = document.createElement("a");
      link.href = jsonString;
      link.download = `backup_crosscheck_${this.state.username}.txt`;
      link.click();

      //const filedecodeAttachX = JSON.stringify(this.state.jsonBackupRestore);
      //this.setState({filedecodeAttachX: filedecodeAttachX, downloadX: true})
    }

    clickUpload = (e) => {
       e.preventDefault();
       this.setState({jsonBackupRestore: [],jsonContractList: [], attachJson: true})
    }

    clickExit = (e) => {
       e.preventDefault();
       this.setState({jsonBackupRestore: [],jsonContractList: [],sendfiles: true,completedata: false,backupfiles: false,restorefiles: true,uploadfiles: true,exitprogram: true, attachJson: false})
       this.handleChangeOption('General')
    }

    clickSee = (e,objectX) => {
      e.preventDefault();
      this.setState({dialogOpenInfo: true,dialogMessage: Base64.decode(objectX),dialogTitle: 'Confirm: 3001',})
    }

    clickRecovery = (e,optX) => {
      const {userSession} = this.state
      const storage = new Storage({ userSession });
      const options = { decrypt: false, verify: false }
      if (optX === 'contractlist.json'){
        let jsonBlockstack4 = []
        this.clickRestoreContractList(jsonBlockstack4)
      }
    }

    clickRestoreContractList = (jsonContractList) => {
      const {userSession} = this.state
      const storage = new Storage({ userSession });
      const options = { decrypt: false, verify: false }
      const largoX = this.state.jsonBackupRestore.length
      let salida = ''
      this.state.jsonBackupRestore.map( (todo, i) => {
          Promise.all(
             [this.functionBackupRestore(todo.item,todo.nombre,jsonContractList,salida)]
          ).then(
            (resolve) =>{
              salida = resolve[0].salida
            },
            (reject) =>{
              salida = reject[0].salida
            }
          )
      })
    }

    functionBackupRestore = (itemX,nombreX,jsonContractList,salida) => {
        return new Promise ((resolve1, reject1) => {
          if (nombreX.substring(0,10) === 'workorder_' ||
              nombreX.substring(0,6)  === 'blank_' ||
              nombreX.substring(0,12) === 'spreadsheet_' ||
              nombreX.substring(0,9)  === 'uploaded_' ||
              nombreX.substring(0,9)  === 'proforma_' ||
              nombreX.substring(0,12) === 'maintenance_' ||
              nombreX.substring(0,9)  === 'delivery_' ) {
            let splitX = nombreX.split('_')
            let typeX = splitX[0]
            let numberX = splitX[1]
            if (splitX[2] === undefined){

                splitX = numberX.split('.')
                numberX = splitX[0]
                Promise.all(
                   [this.clickRestoreContractList2(typeX,numberX,salida)]
                ).then(
                  (resolve2) =>{resolve1({salida:salida})},
                  (reject2) =>{reject1({salida:salida})}
                )
             }
          }
       })
    }

    clickRestoreContractList2 = (typeX,numberX,salida) => {
      const {userSession} = this.state
      const storage = new Storage({ userSession });
      const options = { decrypt: false, verify: false }
      console.log(`${typeX}_${numberX}.json`)
      return new Promise ((resolve4, reject4) => {
          getFileDB(this.state.username, `${typeX}_${numberX}.json`)
            .then((fileContents) => {
               if(fileContents) {
                  const jsonBlockstack1 = JSON.parse(fileContents)
                  const jsonBlockstack2 = jsonBlockstack1.data
                  let jsonBlockstack5 = '[]'
                  if (jsonBlockstack2 !== null){
                      const jsonBlockstack3 = jsonBlockstack2.dataobject
                      const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                      if (jsonBlockstack4.substring(0,1) === '"') {
                         jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                      } else {
                         jsonBlockstack5 = jsonBlockstack4
                      }
                  }
                  let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                  let jsonBlockstack40 = JSON.parse(jsonBlockstack5)
                  const {idParadigma,signature,statusLifeCycle,contractPolicy,statusActive,statusActiveAfterPublished,statusBlockchain,usernameInsert,dateInsert,
                    usernameUpdate,dateUpdate,usernameDelete,dateDelete,typeContract,configurationContractNumber,startDate,endDate,subject,signatureAndPayment,dateContract,
                    registerTxId} = jsonBlockstack40
                    console.log(jsonBlockstack40)
                    salida =`{"id":"${idParadigma}","typeContract":"${typeContract}","configurationContractNumber":"${configurationContractNumber}","idContainer":"${configurationContractNumber}","idBillOfLading":"${configurationContractNumber}","idTypeBillOfLading":"${typeContract}","dateLogisticContract":"${dateContract}","active":"true","subject":"${subject}","statusBlockchain":"${statusBlockchain}","activeUserGroup":true,"confirmSign":true,"activeDeliverable":true,"activeDataDashboard":false,"encryptDecryptFile":true,"signatureAndPayment":"SignatureOnly","active_after_published":"true","registerTxId":"${registerTxId}"}`
                    this.getBackupRestore(typeX,numberX,salida)
                    resolve4({salida:salida})
                }
            })
            .catch(error => {
              resolve4({salida:salida})
            });
        });
    }

    getBackupRestore = (typeX,numberX,salida) => {
      const {userSession} = this.state
      const storage = new Storage({ userSession });
      const options = { decrypt: false, verify: false }
      return new Promise ((resolve6, reject6) => {
          getFileDB(this.state.username, `contractlist.json`)
            .then((fileContents) => {
                  const jsonBlockstack1 = JSON.parse(fileContents)
                  const jsonBlockstack2 = jsonBlockstack1.data
                  let jsonBlockstack5 = '[]'
                  if (jsonBlockstack2 !== null){
                     const jsonBlockstack3 = jsonBlockstack2.dataobject
                     const jsonBlockstack4 = jsonBlockstack3.replace(/\\/g,"");
                     if (jsonBlockstack4.substring(0,1) === '"') {
                        jsonBlockstack5 = jsonBlockstack4.substring(1,jsonBlockstack4.length - 1)
                     } else {
                        jsonBlockstack5 = jsonBlockstack4
                     }
                  }
                  let jsonBlockstack6 = JSON.parse(jsonBlockstack5)
                  let sigueX = true
                  let largoX = jsonBlockstack6.length
                  jsonBlockstack6.map( (todo2, i2) => {
                    console.log(typeX.toString())
                    console.log(numberX.toString())
                    console.log(todo2.typeContract.toString())
                    console.log(todo2.configurationContractNumber.toString())
                     if (typeX.toString() === todo2.typeContract.toString() && numberX.toString() === todo2.configurationContractNumber.toString() ){
                        sigueX = false
                     }
                     if (i2 === largoX - 1){
                       if (sigueX === true) {
                         const jsonBlockstack7 = jsonBlockstack5.substring(1,jsonBlockstack5.length - 1)
                         const salidaX =`[${jsonBlockstack7},${salida}]`
                         Promise.all(
                            [this.putBackupRestore(salidaX)]
                         ).then(
                           (resolve3) =>{resolve6()},
                           (reject3) =>{resolve6()}
                         )
                       }else{
                         resolve6()
                       }
                     }
                  })
            })
            .catch(error => {
               console.log(error)
               resolve6()
            });
        });
    }

    putBackupRestore = (salida) => {
      const {userSession} = this.state
      const storage = new Storage({ userSession });
      const options2 = {contentType: 'application/json', encrypt: false, dangerouslyIgnoreEtag: true }
      console.log(salida)
      return new Promise ((resolve5, reject5) => {
          putFileDB(this.state.username, `contractlist.json`, 'Crosscheck,_Setting', JSON.stringify(salida), JSON.stringify(options2))
             .then(() => {
                resolve5()
             })
             .catch(error => {
                reject5()
             });
      });
    }

    returnProps = () => {
      this.setState({downloadX:false})
      this.setState({filedecodeAttachX:''})
    }

    returnUploadContract = (file, file64) => {
      const fileObject = JSON.parse(file)
      this.setState({filedecodeAttachJsonX: file, fileAttachJsonX: file64, jsonBackupRestore:fileObject, attachJson: false, restorefiles: true})
    }


    render() {
        const {jsonBlockstack} = this.state
        const {jsonBlockstackY} = this.state
        const {jsonBlockstackZ} = this.state
        const {templatesAllLocal} = this.state
        const {idx} = this.state
        const clickOtherX = this.state.displayOther
        const nameX2 = this.state.nameOther
        const titleX2 = this.state.titleOther
        const priorityX2 = this.state.priorityOther
        const taxX2 = this.state.taxOther
        const fileX2 = this.state.file
        const idxX2 = this.state.idx
        const secondaryNameX2 = this.state.secondaryName

        const paymentform=this.state.paymentform
        const participants=this.state.participants
        const pay=this.state.pay
        const trace=this.state.trace
        const deliverable=this.state.deliverable
        const network=this.state.network
        const addons=this.state.addons

        const activarparticipants=this.state.activarparticipants
        const certificarfirma=this.state.certificarfirma
        const activarentregable=this.state.activarentregable
        const certificarreglas=this.state.certificarreglas

        //let bRole = false
        let selectedContracts = false
        let selectedContractMasterFile = false
        let selectedContractMasterFileIoT = false
        let selectedContractMasterFileDeliverable = false
        let selectedIoTDevice = false
        let selectedGeneral = false
        let selectedRole = false
        let selectedTag = false
        //let selectedQuickSimulator = false
        let selectedRBackupRestore = false
        let titleX = 'Configuration'
        let subtitleX = 'Maintain'
        let placeholderX1 = "Select an Option"
        if (this.state.language === 'English'){
          titleX = "Configuration"
          subtitleX = "Maintain"
          placeholderX1 = "Select an Option"
        }
        if (this.state.language === 'French'){
          titleX = "Configuration"
          subtitleX = "Maintenir"
          placeholderX1 = "Sélectionner une Option"
        }
        if (this.state.language === 'Spanish'){
          titleX = "Configuración"
          subtitleX = "Mantener"
          placeholderX1 = "Seleccione una Opción"
        }
        if (this.state.language === 'Portuguese'){
          titleX = "Configuração"
          subtitleX = "Manter"
          placeholderX1 = "Selecione uma Opção"
        }
        if (this.state.language === 'Swedish'){
          titleX = "Konfiguration"
          subtitleX = "Upprätthålla"
          placeholderX1 = "Välj ett Alternativ"
        }
        if (this.state.language === 'Netherlands'){
          titleX = "Configuratie"
          subtitleX = "Onderhouden"
          placeholderX1 = "Kies een Optie"
        }
        if (this.state.language === 'Russian'){
          titleX = "конфигурация"
          subtitleX = "поддерживать"
          placeholderX1 = "Выберите опцию"
        }
        if (this.state.language === 'Japanese'){
          titleX = "設定"
          subtitleX = "維持する"
          placeholderX1 = "オプションを選択"
        }
        if (this.state.language === 'Chinese'){
          titleX = "组态"
          subtitleX = "保持"
          placeholderX1 = "选择一个选项"
        }
        if (this.state.language === 'German'){
          titleX = "Aufbau"
          subtitleX = "Pflegen"
          placeholderX1 = "Wähle eine Option"
        }
        if (this.state.language === 'Italian'){
          titleX = "Configurazione"
          subtitleX = "Mantenere"
          placeholderX1 = "Seleziona un'opzione"
        }

        if (this.state.selectedConfiguration === "Contracts"){
           selectedContracts = true
        }
        if (this.state.selectedConfiguration === "ContractMasterFile"){
           selectedContractMasterFile = true
        }
        if (this.state.selectedConfiguration === "ContractMasterFileIoT"){
           selectedContractMasterFileIoT = true
        }
        if (this.state.selectedConfiguration === "ContractMasterFileDeliverable"){
           selectedContractMasterFileDeliverable = true
        }
        if (this.state.selectedConfiguration === "IoTDevice"){
           selectedIoTDevice = true
        }
        if (this.state.selectedConfiguration === "General"){
           selectedGeneral = true
        }
        if (this.state.selectedConfiguration === "Role"){
           selectedRole = true
           //bRole = true
        }
        if (this.state.selectedConfiguration === "Tag"){
           selectedTag = true
           //bRole = true
        }
        if (this.state.selectedConfiguration === "QuickSimulator"){
           //selectedQuickSimulator = true
        }
        if (this.state.selectedConfiguration === "BackupRestore"){
           selectedRBackupRestore = true
        }

        let colorThemeX = 'Blue'
        let colorThemeX2 = 'info'
        if (localStorage["colorTheme"]) {colorThemeX = localStorage.getItem('colorTheme')}
        if (colorThemeX === 'Blue') {colorThemeX2 = 'info'}
        if (colorThemeX === 'Green') {colorThemeX2 = 'success'}
        if (colorThemeX === 'Grey') {colorThemeX2 = 'secondary'}
        if (colorThemeX === 'Dark') {colorThemeX2 = 'dark'}

        const currencyX = currency.CcyNtry
        const currencyCryptoX = currencyCrypto.CcyNtry
        const currencyPaymentX = currencyPayment.CcyNtry

        let bPairsX = false
        if (this.state.opcionMasterFile === 'Business Pairs Contact'){
          bPairsX = true
        }

        const mimeTypeX = 'text/plain'

        return (
          <>
            { !this.state.colorDark ?
              <Container fluid className="px-0">
                  <Card theme={colorThemeX2} style={{ color: "white" }}>
                    <table>
                      <tbody>
                        <tr>
                          <td>
                            &nbsp;&nbsp;<div className="fa fa-info"></div>
                          </td>
                          <td>
                             &nbsp;&nbsp;<FormattedMessage id="configuration.configuration" />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </Card>
              </Container>
            : null
            }
            <Container fluid className="main-content-container px-4" style={ this.state.colorDark ? { backgroundColor:'#060a0f'} : {}} >
              <Row noGutters className="page-header py-4">
                <TituloPagina
                  sm="4"
                  title={titleX}
                  subtitle={subtitleX}
                  className="text-sm-left"
                />
              </Row>
              <Confirmacion
                  handleDialog={this.handleDialog}
                  dialogMessage={this.state.dialogMessage}
                  dialogOpen={this.state.dialogOpen}
                  dialogTitle={this.state.dialogTitle}
              />
              <Confirmacion2
                  handleDialog={this.handleDialog}
                  dialogMessage={this.state.dialogMessage}
                  dialogOpen={this.state.dialogOpenServer}
                  dialogTitle={this.state.dialogTitle}
              />
              <Confirmacion3
                  handleDialog={this.handleDialog}
                  dialogMessage={this.state.dialogMessage}
                  dialogOpen={this.state.dialogOpenInfo}
                  dialogTitle={this.state.dialogTitle}
              />
              <Confirmacion4
                  handleDialog={this.handleDialog}
                  dialogMessage={this.state.dialogMessage}
                  dialogOpen={this.state.dialogOpenCargaDato}
                  dialogTitle={this.state.dialogTitle}
                  idUsuarioX={this.state.idUsuarioX}
                  idUsuarioDisabledX={this.state.idUsuarioDisabledX}
                  handleIdUsuario={this.handleIdUsuario}

              />
              {this.state.downloadX ?
                <MyDownload filedecodeAttachX={this.state.filedecodeAttachX} nameAttachX={`backup_crosscheck_${this.state.username}.txt`} typeAttachX={'text'} returnProps={this.returnProps} typeAttachText={true} typeAttachImage={false} typeAttachPdf={false} typeAttachAudio={false} typeAttachVideo={false} />
              : null }
              <Card style={ this.state.colorDark ? { backgroundColor:'#0b151d', color: 'White'} : {color: 'Black', backgroundColor:"#F2EACE" }} >
                <Row>
                  <Col md="1"></Col>
                  <Col md="10">
                    <br></br>
                    <Nav tabs pills className="myTab" style={ this.state.colorDark ? { backgroundColor:'#0b151d'} : {}}>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '1' })}
                          onClick={() => this.handleChangeOption("General")}
                        >
                          <FormattedMessage id="configuration.general" />
                        </NavLink>
                      </NavItem>

                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '2' })}
                          onClick={() => this.handleChangeOption("Role")}
                        >
                          <FormattedMessage id="configuration.rolesandpermissions" />
                        </NavLink>
                      </NavItem>

                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '3' })}
                          onClick={() => this.handleChangeOption("Contracts")}
                        >
                          <FormattedMessage id="configuration.contracts" />
                        </NavLink>
                      </NavItem>

                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '4' })}
                          onClick={() => this.handleChangeOption("ContractMasterFile")}
                        >
                          <FormattedMessage id="configuration.contractmasterfiles" />
                        </NavLink>
                      </NavItem>

                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '9' })}
                          onClick={() => this.handleChangeOption("ContractMasterFileDeliverable")}
                        >
                          <FormattedMessage id="configuration.contractmasterfilesDeliverable" />
                        </NavLink>
                      </NavItem>

                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '10' })}
                          onClick={() => this.handleChangeOption("ContractMasterFileIoT")}
                        >
                          <FormattedMessage id="configuration.contractmasterfilesIoT" />
                        </NavLink>
                      </NavItem>

                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '5' })}
                          onClick={() => this.handleChangeOption("IoTDevice")}
                        >
                          <FormattedMessage id="configuration.iotdevice" />
                        </NavLink>
                      </NavItem>

                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '6' })}
                          onClick={() => this.handleChangeOption("Tag")}
                        >
                          <FormattedMessage id="configuration.tag" />
                        </NavLink>
                      </NavItem>

                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '7' })}
                          onClick={() => this.handleChangeOption("QuickSimulator")}
                        >
                          <FormattedMessage id="configuration.quicksimulator" />
                        </NavLink>
                      </NavItem>

                      <NavItem>
                        <NavLink
                          className={classnames({ active: this.state.activeTab === '8' })}
                          onClick={() => this.handleChangeOption("BackupRestore")}
                        >
                          <FormattedMessage id="configuration.backuprestore" />
                        </NavLink>
                      </NavItem>
                    </Nav>
                  </Col>
                  <Col md="1"></Col>
                </Row>
                <Row>&nbsp;</Row>
              </Card>
              {selectedContractMasterFileIoT ?
                <Row>
                  <Col>
                    <Form style={ this.state.colorDark ? { backgroundColor:'#0b151d', fontSize:13} : {fontSize:13}}>
                      <Row form>
                        <Col md="1"></Col>
                        <Col md="3">
                          <label>&nbsp;</label>
                          <FormSelect
                              id="TypeMasterFile"
                              style={ this.state.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                              innerRef={this.c01MasterFile}
                              placeholder="Select an Option"
                              onChange={this.goMasterFile}
                          >
                          <option value="SelectOptionMasterFile" selected disabled hidden>{placeholderX1}</option>
                          <option style={this.state.colorDark ? { color:'orange'} : {color:'darkblue'}} value="Category">Device ID</option>
                          <option style={this.state.colorDark ? { color:'orange'} : {color:'darkblue'}} value="SensorId">Sensor</option>
                          <option style={this.state.colorDark ? { color:'orange'} : {color:'darkblue'}} value="UnitMeasurementTemperature">Unit Measurement Temperature</option>
                          <option style={this.state.colorDark ? { color:'orange'} : {color:'darkblue'}} value="UnitMeasurementHumidity">Unit Measurement Humidity</option>
                          <option style={this.state.colorDark ? { color:'orange'} : {color:'darkblue'}} value="UnitMeasurementGasControl">Unit Measurement Gas Control</option>
                          <option style={this.state.colorDark ? { color:'orange'} : {color:'darkblue'}} value="UnitMeasurementGPS">Unit Measurement GPS</option>
                          <option style={this.state.colorDark ? { color:'orange'} : {color:'darkblue'}} value="UnitFrecuency">Unit Frecuency</option>
                          <option style={this.state.colorDark ? { color:'orange'} : {color:'darkblue'}} value="UnitTimeUnit">Unit Time Unit</option>
                          <option style={this.state.colorDark ? { color:'orange'} : {color:'darkblue'}} value="ErrorAction">Error Action</option>
                          </FormSelect>
                        </Col>

                        <Col md="8">
                          <label>&nbsp;</label>
                          {this.state.displayMasterFile ?
                            <NewMasterFile typeMasterFile={this.state.typeMasterFile} crearMasterFile={this.crearMasterFile} opcionMasterFile={this.state.opcionMasterFile} jsonBlockstack={this.state.jsonBlockstack} code={this.state.code} colorletter={this.state.colorletter} hex={this.state.hex} description={this.state.description} jsonRol={this.state.jsonRol} modifying={this.state.modifying} colorDark={this.state.colorDark} />
                         : null }
                        </Col>
                      </Row>
                      <Row>
                        <Col md="1"></Col>
                        <Col md="10">
                          <label>&nbsp;</label>
                          {this.state.displayMasterFile ?
                                 <Table size="sm" className="text-center" responsive hover striped>
                                    <thead>
                                      <tr>
                                        <th style={{ width: "30px" }}><FormattedMessage id="configuration.code" /></th>
                                        <th style={{ width: "160px" }}><FormattedMessage id="configuration.description" /></th>
                                        <th style={{ width: "20px" }}><FormattedMessage id="configuration.edit" /></th>
                                        <th style={{ width: "20px" }}><FormattedMessage id="configuration.delete" /></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {jsonBlockstack.map((todo, i) => {
                                        let bEditDelete = true
                                        if (this.state.opcionMasterFile === 'Concepts for Payment Forms'){
                                          if (todo.code === 'Deliverable' || todo.code === 'Advance' || todo.code === 'Payment'){
                                             bEditDelete = false
                                          }
                                        }
                                        return (
                                            <tr key={i}>
                                                <td style={this.state.colorDark ? {color: 'white'} : {color: 'black'}}>{todo.code}</td>
                                                <td style={this.state.colorDark ? {color: 'white'} : {color: 'black'}}>{todo.description}</td>
                                                {bEditDelete ?
                                                  <>
                                                     <td><Button pill theme="success" onClick={e=>this.clickEditMasterFile(e, i)}><FontAwesomeIcon icon={faEdit} /></Button></td>
                                                     <td><Button pill theme="danger" onClick={e=>this.clickRemoveMasterFile(e, i, todo.code)}><FontAwesomeIcon icon={faTimes} /></Button></td>
                                                  </>
                                                :
                                                  <>
                                                    <td></td>
                                                    <td></td>
                                                  </>
                                                }
                                            </tr>
                                         )})}
                                    </tbody>
                                  </Table>
                         : null }
                        </Col>
                        <Col md="1"></Col>
                      </Row>
                    </Form>
                  </Col>
                </Row>
              :
                null
              }
              {selectedContractMasterFileDeliverable ?
                <Row>
                  <Col>
                    <Form style={ this.state.colorDark ? { backgroundColor:'#0b151d', fontSize:13} : {fontSize:13}}>
                      <Row form>
                        <Col md="1"></Col>
                        <Col md="3">
                          <label>&nbsp;</label>
                          <FormSelect
                              id="TypeMasterFile"
                              style={ this.state.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                              innerRef={this.c01MasterFile}
                              placeholder="Select an Option"
                              onChange={this.goMasterFileDeliverable}
                          >
                          <option value="SelectOptionMasterFile" selected disabled hidden>{placeholderX1}</option>
                          <option style={this.state.colorDark ? { color:'orange'} : {color:'darkblue'}} value="Turno">Turno</option>
                          <option style={this.state.colorDark ? { color:'orange'} : {color:'darkblue'}} value="Actividades">Actividades</option>
                          <option style={this.state.colorDark ? { color:'orange'} : {color:'darkblue'}} value="Proposito">Propósito</option>
                          <option style={this.state.colorDark ? { color:'orange'} : {color:'darkblue'}} value="Sector">Sector</option>
                          <option style={this.state.colorDark ? { color:'orange'} : {color:'darkblue'}} value="EstadoPozo">Estado Pozo</option>
                          <option style={this.state.colorDark ? { color:'orange'} : {color:'darkblue'}} value="TipoMuestra">Tipo Muestra</option>
                          <option style={this.state.colorDark ? { color:'orange'} : {color:'darkblue'}} value="EstadoSondaje">Estado Sondaje</option>
                          <option style={this.state.colorDark ? { color:'orange'} : {color:'darkblue'}} value="Herramienta">Herramienta</option>
                          <option style={this.state.colorDark ? { color:'orange'} : {color:'darkblue'}} value="TipoPerforacion">Tipo Perforacion</option>
                          <option style={this.state.colorDark ? { color:'orange'} : {color:'darkblue'}} value="Perforacion">Perforación</option>
                          <option style={this.state.colorDark ? { color:'orange'} : {color:'darkblue'}} value="SobrecargaNatural">Perforación - Sobrecarga Natural</option>
                          <option style={this.state.colorDark ? { color:'orange'} : {color:'darkblue'}} value="SobrecargaNoNatural">Perforación - Sobrecarga No Natural</option>
                          <option style={this.state.colorDark ? { color:'orange'} : {color:'darkblue'}} value="RocaMuestraSeca">Perforación - Roca Muestra Seca</option>
                          <option style={this.state.colorDark ? { color:'orange'} : {color:'darkblue'}} value="RocaMuestraHumeda">Perforación Roca Muestra con Agua</option>
                          <option style={this.state.colorDark ? { color:'orange'} : {color:'darkblue'}} value="RocaMuestraHumedaMartillo">Perforación Roca Muestra con Agua (sólo Martillo)</option>
                          <option style={this.state.colorDark ? { color:'orange'} : {color:'darkblue'}} value="PozoMonitoreo">Monitoreo</option>

                          </FormSelect>
                        </Col>

                        <Col md="8">
                          <label>&nbsp;</label>
                          {this.state.displayMasterFile ?
                            <NewMasterFile typeMasterFile={this.state.typeMasterFile} crearMasterFile={this.crearMasterFile} opcionMasterFile={this.state.opcionMasterFile} jsonBlockstack={this.state.jsonBlockstack} code={this.state.code} colorletter={this.state.colorletter} hex={this.state.hex} description={this.state.description} jsonRol={this.state.jsonRol} modifying={this.state.modifying} colorDark={this.state.colorDark} />
                         : null }
                         {this.state.displayDiametroOcupadoKPI ?
                            <NewMasterFile typeMasterFile={'diametro_ocupado_kpi'} tramo={this.state.codeDiametroOcupado} tramo2={this.state.descriptionDiametroOcupado} jsonDiametroOcupado={this.state.jsonDiametroOcupado} crearMasterFile={this.crearMasterFile} opcionMasterFile={this.state.opcionMasterFile} jsonBlockstack={this.state.jsonBlockstack} code={this.state.code} colorletter={this.state.colorletter} hex={this.state.hex} description={this.state.description} jsonRol={this.state.jsonRol} modifying={this.state.modifying} colorDark={this.state.colorDark} />
                         : null }

                        </Col>
                      </Row>
                      <Row>
                        <Col md="1"></Col>
                        <Col md="10">
                          <label>&nbsp;</label>
                          {this.state.displayMasterFile ?
                                 <Table size="sm" className="text-center" responsive hover striped>
                                    <thead>
                                      <tr>
                                        <th style={{ width: "30px" }}><FormattedMessage id="configuration.code" /></th>
                                        <th style={{ width: "160px" }}><FormattedMessage id="configuration.description" /></th>
                                        <th style={{ width: "20px" }}><FormattedMessage id="configuration.edit" /></th>
                                        <th style={{ width: "20px" }}><FormattedMessage id="configuration.delete" /></th>
                                        {this.state.bEditRango ?
                                          <th style={{ width: "20px" }}>Diámetro Ocupado (KPI)</th>
                                        : null
                                        }
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {jsonBlockstack.map((todo, i) => {
                                        let bEditRango = false
                                        if (this.state.opcionMasterFile === 'Perforacion'){
                                             bEditRango = true
                                        }
                                        return (
                                            <tr key={i}>
                                                <td style={this.state.colorDark ? {color: 'white'} : {color: 'black'}}>{todo.code}</td>
                                                <td style={this.state.colorDark ? {color: 'white'} : {color: 'black'}}>{todo.description}</td>
                                                <td><Button pill theme="success" onClick={e=>this.clickEditMasterFile(e, i)}><FontAwesomeIcon icon={faEdit} /></Button></td>
                                                <td><Button pill theme="danger" onClick={e=>this.clickRemoveMasterFile(e, i, todo.code)}><FontAwesomeIcon icon={faTimes} /></Button></td>
                                                {this.state.bEditRango ?
                                                  <th style={{ width: "20px" }}>
                                                    <strong style={{cursor: 'pointer'}} onClick={e=>this.diametroOcupadoKPI(e,todo.code, todo.description)}>
                                                        <img src="images/kpi.png" weight="40" height="40" alt=""/>
                                                    </strong>
                                                  </th>
                                                : null
                                                }
                                            </tr>
                                         )})}
                                    </tbody>
                                  </Table>
                          : null }
                          {this.state.displayDiametroOcupadoKPI ?
                                <Table size="sm" className="text-center" responsive hover striped>
                                   <thead>
                                     <tr>
                                       <th style={{ width: "30px" }}><FormattedMessage id="configuration.code" /></th>
                                       <th style={{ width: "160px" }}><FormattedMessage id="configuration.description" /></th>
                                       <th style={{ width: "20px" }}><FormattedMessage id="configuration.edit" /></th>
                                       <th style={{ width: "20px" }}><FormattedMessage id="configuration.delete" /></th>
                                     </tr>
                                   </thead>
                                   <tbody>
                                     {this.state.jsonDiametroOcupado.map((todo, i) => {
                                       if (this.state.opcionMasterFile === todo.perforacion && this.state.codeDiametroOcupado === todo.tramo){
                                         return (
                                             <tr key={i}>
                                                 <td style={this.state.colorDark ? {color: 'white'} : {color: 'black'}}>{todo.code}</td>
                                                 <td style={this.state.colorDark ? {color: 'white'} : {color: 'black'}}>{todo.description}</td>
                                                 <td><Button pill theme="success" onClick={e=>this.clickEditMasterFileDiametro(e, i)}><FontAwesomeIcon icon={faEdit} /></Button></td>
                                                 <td><Button pill theme="danger" onClick={e=>this.clickRemoveMasterFileDiametro(e, i, todo.code)}><FontAwesomeIcon icon={faTimes} /></Button></td>
                                             </tr>
                                          )
                                        }
                                      })}
                                   </tbody>
                                 </Table>
                          : null }

                        </Col>
                        <Col md="1"></Col>
                      </Row>
                    </Form>
                  </Col>
                </Row>
              :
                null
              }
              {selectedContractMasterFile ?
                  <Row>
                    <Col>
                      <Form style={ this.state.colorDark ? { backgroundColor:'#0b151d', fontSize:13} : {fontSize:13}}>
                        <Row form>
                          <Col md="1"></Col>
                          <Col md="3">
                            <label>&nbsp;</label>
                            <FormSelect
                                id="TypeMasterFile"
                                style={ this.state.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                innerRef={this.c01MasterFile}
                                placeholder="Select an Option"
                                onChange={this.goMasterFile}
                            >
                            <option value="SelectOptionMasterFile" selected disabled hidden>{placeholderX1}</option>
                            <option style={this.state.colorDark ? { color:'orange'} : {color:'darkblue'}} value="Client Work Order">Client Work Order</option>
                            <option style={this.state.colorDark ? { color:'orange'} : {color:'darkblue'}} value="Concepts for Payment Forms">Concepts for Payment Forms</option>
                            <option style={this.state.colorDark ? { color:'orange'} : {color:'darkblue'}} value="Business Pairs Contact">Business Peers Contact</option>
                            <option style={this.state.colorDark ? { color:'orange'} : {color:'darkblue'}} value="Industrial Maintenance (Associated to)">Industrial Maintenance (Associated to)</option>
                            </FormSelect>
                          </Col>

                          <Col md="8">
                            <label>&nbsp;</label>
                            {this.state.displayMasterFile ?
                              <NewMasterFile typeMasterFile={this.state.typeMasterFile} crearMasterFile={this.crearMasterFile} opcionMasterFile={this.state.opcionMasterFile} jsonBlockstack={this.state.jsonBlockstack} code={this.state.code} colorletter={this.state.colorletter} hex={this.state.hex} description={this.state.description} jsonRol={this.state.jsonRol} modifying={this.state.modifying} colorDark={this.state.colorDark} remoteUserX={this.state.remoteUserX} activeRemoteUserX={this.state.activeRemoteUserX} />
                           : null }
                          </Col>
                        </Row>
                        <Row>
                          <Col md="1"></Col>
                          <Col md="10">
                            <label>&nbsp;</label>
                            {this.state.displayMasterFile ?
                              <>
                                {bPairsX ?
                                  <Table size="sm" className="text-center" responsive hover striped>
                                      <thead>
                                        <tr>
                                          <th style={{ width: "30px" }}>Usuario Remoto</th>
                                          <th style={{ width: "160px" }}>Estado</th>
                                          <th style={{ width: "20px" }}><FormattedMessage id="configuration.edit" /></th>
                                          <th style={{ width: "20px" }}><FormattedMessage id="configuration.delete" /></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {jsonBlockstack.map((todo, i) => {
                                          return (
                                              <tr key={i}>
                                                  <td style={this.state.colorDark ? {color: 'white'} : {color: 'black'}}>{todo.remoteuser}</td>
                                                  {todo.active ?
                                                     <td style={this.state.colorDark ? {color: 'white'} : {color: 'black'}}>Activo</td>
                                                  :
                                                     <td style={this.state.colorDark ? {color: 'white'} : {color: 'black'}}>Inactivo</td>
                                                  }
                                                  <td><Button pill theme="success" onClick={e=>this.clickEditMasterUserlistRemote(e, i)}><FontAwesomeIcon icon={faEdit} /></Button></td>
                                                  <td><Button pill theme="danger" onClick={e=>this.clickRemoveMasterFile(e, i, todo.code)}><FontAwesomeIcon icon={faTimes} /></Button></td>
                                              </tr>
                                           )})}
                                      </tbody>
                                    </Table>
                                  :
                                    <Table size="sm" className="text-center" responsive hover striped>
                                       <thead>
                                         <tr>
                                           <th style={{ width: "30px" }}><FormattedMessage id="configuration.code" /></th>
                                           <th style={{ width: "160px" }}><FormattedMessage id="configuration.description" /></th>
                                           <th style={{ width: "20px" }}><FormattedMessage id="configuration.edit" /></th>
                                           <th style={{ width: "20px" }}><FormattedMessage id="configuration.delete" /></th>
                                         </tr>
                                       </thead>
                                       <tbody>
                                         {jsonBlockstack.map((todo, i) => {
                                           let bEditDelete = true
                                           if (this.state.opcionMasterFile === 'Concepts for Payment Forms'){
                                             if (todo.code === 'Deliverable' || todo.code === 'Advance' || todo.code === 'Payment'){
                                                bEditDelete = false
                                             }
                                           }
                                           return (
                                               <tr key={i}>
                                                   <td style={this.state.colorDark ? {color: 'white'} : {color: 'black'}}>{todo.code}</td>
                                                   <td style={this.state.colorDark ? {color: 'white'} : {color: 'black'}}>{todo.description}</td>
                                                   {bEditDelete ?
                                                     <>
                                                        <td><Button pill theme="success" onClick={e=>this.clickEditMasterFile(e, i)}><FontAwesomeIcon icon={faEdit} /></Button></td>
                                                        <td><Button pill theme="danger" onClick={e=>this.clickRemoveMasterFile(e, i, todo.code)}><FontAwesomeIcon icon={faTimes} /></Button></td>
                                                     </>
                                                   :
                                                     <>
                                                       <td></td>
                                                       <td></td>
                                                     </>
                                                   }
                                               </tr>
                                            )})}
                                       </tbody>
                                     </Table>
                                  }
                                </>
                           : null }
                          </Col>
                          <Col md="1"></Col>
                        </Row>
                      </Form>
                    </Col>
                  </Row>
              : null }

              {selectedContracts ?
                  <Row>
                    <Col>
                      <Form style={{fontSize:11}}>
                        <Row>
                          <Col md="12">
                               <Table size="sm" className="text-center" responsive hover striped>
                                  <thead>
                                    <tr>
                                      <th style={{ width: "200px" }}><FormattedMessage id="configuration.name" /></th>
                                      <th style={{ width: "120px" }}><FormattedMessage id="configuration.active" /></th>
                                      <th style={{ width: "120px" }}><FormattedMessage id="tab.paymentform" /></th>
                                      <th style={{ width: "120px" }}><FormattedMessage id="tab.participants" /></th>
                                      <th style={{ width: "120px" }}><FormattedMessage id="tab.pay" /></th>
                                      <th style={{ width: "120px" }}><FormattedMessage id="tab.deliverable" /></th>
                                      <th style={{ width: "120px" }}><FormattedMessage id="tab.trace" /></th>
                                      <th style={{ width: "120px" }}><FormattedMessage id="tab.network" /></th>
                                      <th style={{ width: "120px" }}><FormattedMessage id="tab.addons" /></th>
                                      <th style={{ width: "120px" }}><FormattedMessage id="tab.certificates" /></th>
                                      <th style={{ width: "150px" }}><FormattedMessage id="configuration.more" /></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {templatesAllLocal.map((todo, i) => {
                                      if (todo.paymentform === undefined){ todo.paymentform = true }
                                      if (todo.participants === undefined){ todo.participants = true }
                                      if (todo.pay === undefined){ todo.pay = true }
                                      if (todo.trace === undefined){ todo.trace = true }
                                      if (todo.deliverable === undefined){ todo.deliverable = true }
                                      if (todo.network === undefined){ todo.network = true }
                                      if (todo.addons === undefined){ todo.addons = true }
                                      if (todo.certificates === undefined){ todo.certificates = true }
                                      let displayMore = true
                                      let bIsActive = false
                                      let themeMoreX="light"
                                      if (todo.isActive){
                                         displayMore = false
                                         themeMoreX="success"
                                      }
                                      let setColorInfo = false
                                      if (this.state.setItemInfo === i) {
                                        setColorInfo = true
                                      }
                                      if (todo.name === 'Environment & Sustainability' || todo.name === 'Manufacturing' || todo.name === 'Rental Contracts' || todo.name === 'Security'){
                                         bIsActive = true
                                         todo.certificates = false
                                      }
                                      return (
                                          <tr key={i} onMouseEnter={()=>this.onMouseEnterHandler(i)} onMouseLeave={()=>this.onMouseLeaveHandler(i)}>
                                              { setColorInfo ?
                                                <>
                                                {todo.isActive ?
                                                   <td style={this.state.colorDark ? {color:'orange', fontWeight: "bold"} : {color:'blue', fontWeight: "bold"}}>{todo.name}</td>
                                                :
                                                   <td style={{ fontWeight: "bold" }}>{todo.name}</td>
                                                }
                                                </>
                                              :
                                                <>
                                                {todo.isActive ?
                                                   <td style={this.state.colorDark ? {color:'orange'} : {color:'blue'}}>{todo.name}</td>
                                                :
                                                   <td>{todo.name}</td>
                                                }
                                                </>
                                              }
                                              <td>
                                                  <FormCheckbox
                                                      inline
                                                      checked={todo.isActive}
                                                      onChange={e=>this.handleChange(e, "isActive", i, todo.name)}
                                                      disabled={bIsActive}
                                                  >
                                                  </FormCheckbox>
                                              </td>
                                              <td>
                                                  <FormCheckbox
                                                      inline
                                                      checked={todo.paymentform}
                                                      onChange={e=>this.handleChange(e, "paymentform", i, '')}
                                                      disabled={true}
                                                  >
                                                  </FormCheckbox>
                                              </td>
                                              <td>
                                                  <FormCheckbox
                                                      inline
                                                      checked={todo.participants}
                                                      onChange={e=>this.handleChange(e, "participants", i, '')}
                                                      disabled={true}
                                                  >
                                                  </FormCheckbox>
                                              </td>
                                              <td>
                                                  <FormCheckbox
                                                      inline
                                                      checked={todo.pay}
                                                      onChange={e=>this.handleChange(e, "pay", i, '')}
                                                      disabled={true}
                                                  >
                                                  </FormCheckbox>
                                              </td>
                                              <td>
                                                  <FormCheckbox
                                                      inline
                                                      checked={todo.deliverable}
                                                      onChange={e=>this.handleChange(e, "deliverable", i, '')}
                                                      disabled={true}
                                                  >
                                                  </FormCheckbox>
                                              </td>
                                              <td>
                                                  <FormCheckbox
                                                      inline
                                                      checked={todo.trace}
                                                      onChange={e=>this.handleChange(e, "trace", i, '')}
                                                      disabled={bIsActive}
                                                  >
                                                  </FormCheckbox>
                                              </td>
                                              <td>
                                                  <FormCheckbox
                                                      inline
                                                      checked={todo.network}
                                                      onChange={e=>this.handleChange(e, "network", i, '')}
                                                      disabled={bIsActive}
                                                  >
                                                  </FormCheckbox>
                                              </td>
                                              <td>
                                                  <FormCheckbox
                                                      inline
                                                      checked={todo.addons}
                                                      onChange={e=>this.handleChange(e, "addons", i, '')}
                                                      disabled={bIsActive}
                                                  >
                                                  </FormCheckbox>
                                              </td>
                                              <td>
                                                  <FormCheckbox
                                                      inline
                                                      checked={todo.certificates}
                                                      onChange={e=>this.handleChange(e, "certificates", i, '')}
                                                      disabled={bIsActive}
                                                  >
                                                  </FormCheckbox>
                                              </td>
                                              {this.state.displayOther ?
                                                  <td></td>
                                              :
                                                  <td><Button pill theme={themeMoreX} disabled={displayMore} onClick={e=>this.clickOther(e, i, todo.name, todo.title, todo.priority, todo.tax, todo.file, todo.secondaryName, todo.paymentform, todo.participants, todo.pay, todo.trace, todo.deliverable, todo.network, todo.addons, todo.activarparticipants, todo.certificarfirma, todo.activarentregable, todo.certificarreglas )}><FontAwesomeIcon icon={faChevronDown} /></Button></td>
                                              }
                                          </tr>
                                       )})}
                                  </tbody>
                                </Table>
                          </Col>
                          <Col md="1"></Col>
                        </Row>
                        <Row></Row>
                        <Row>
                          <Col md="12">
                            {clickOtherX ?
                                <NewMasterFileContractOther nameX={nameX2} secondaryNameX={secondaryNameX2} titleX={titleX2} priorityX={priorityX2} taxX={taxX2} fileX={fileX2} idxX={idxX2} sendOther={this.sendOther} returnOther={this.returnOther} deleteOther={this.deleteOther} paymentform={paymentform} participants={participants} pay={pay} trace={trace} deliverable={deliverable} network={network} addons={addons} activarparticipants={activarparticipants} certificarfirma={certificarfirma} activarentregable={activarentregable} certificarreglas={certificarreglas} colorDark={this.state.colorDark} />
                            :
                                null
                            }
                          </Col>
                        </Row>
                      </Form>
                    </Col>
                  </Row>
              : null }

              {selectedRole ?
                  <Row>
                    <Col>
                      <Form style={{fontSize:13}}>
                        <Row form>
                          <Col md="12">
                            <label>&nbsp;</label>
                            <NewMasterFile typeMasterFile={this.state.typeRole} crearMasterFile={this.crearMasterFile} opcionMasterFile={this.state.opcionRole} jsonBlockstack={this.state.jsonBlockstack} code={this.state.code} colorletter={this.state.colorletter} hex={this.state.hex} description={this.state.description} jsonRol={this.state.jsonRol} modifying={this.state.modifying} colorDark={this.state.colorDark} />
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <label>&nbsp;</label>
                            {this.state.displayRole ?
                                   <Table size="sm" className="text-center" responsive hover striped >
                                      <thead>
                                        <tr>
                                          <th style={{ width: "10px" }}></th>
                                          <th style={{ width: "30px" }}><FormattedMessage id="configuration.code" /></th>
                                          <th style={{ width: "160px"}}><FormattedMessage id="configuration.description" /></th>
                                          <th style={{ width: "120px" }}><FormattedMessage id="tab.paymentform" /></th>
                                          <th style={{ width: "120px" }}><FormattedMessage id="tab.participants" /></th>
                                          <th style={{ width: "120px" }}><FormattedMessage id="tab.pay" /></th>
                                          <th style={{ width: "120px" }}><FormattedMessage id="tab.deliverable" /></th>
                                          <th style={{ width: "120px" }}><FormattedMessage id="tab.trace" /></th>
                                          <th style={{ width: "120px" }}><FormattedMessage id="tab.network" /></th>
                                          <th style={{ width: "120px" }}><FormattedMessage id="tab.addons" /></th>
                                          <th style={{ width: "120px" }}><FormattedMessage id="tab.certificates" /></th>
                                          <th style={{ width: "20px" }}><FormattedMessage id="configuration.edit" /></th>
                                          <th style={{ width: "20px" }}><FormattedMessage id="configuration.delete" /></th>
                                         </tr>
                                      </thead>
                                      <tbody>
                                        {jsonBlockstack.map((todo, i) => {
                                          let buttons = true
                                          let disables = false
                                          if (todo.code === 'Creator' || todo.code === 'Authorizer' || todo.code === 'Observer' ||
                                              todo.code === 'Support' || todo.code === 'Payer' || todo.code === 'PayTo') {
                                             buttons = false
                                             disables = true
                                          }
                                          if (todo.paymentform === undefined){ todo.paymentform = true }
                                          if (todo.participants === undefined){ todo.participants = true }
                                          if (todo.pay === undefined){ todo.pay = true }
                                          if (todo.trace === undefined){ todo.trace = true }
                                          if (todo.deliverable === undefined){ todo.deliverable = true }
                                          if (todo.network === undefined){ todo.network = true }
                                          if (todo.addons === undefined){ todo.addons = true }
                                          if (todo.certificates === undefined){ todo.certificates = true }
                                          let setColorInfo = false
                                          if (this.state.setItemInfo === i) {
                                            setColorInfo = true
                                          }

                                          return (
                                              <tr key={i} onMouseEnter={()=>this.onMouseEnterHandler(i)} onMouseLeave={()=>this.onMouseLeaveHandler(i)}>
                                                  { setColorInfo ?
                                                    <td>
                                                      <strong className="fa fa-info-circle" style={{cursor: 'pointer', fontSize:24, color:'darkred'}} onClick={e=>this.activeInfo(e,i,todo.code)}></strong>
                                                    </td>
                                                  :
                                                    <td className="fa fa-info-circle" style={{fontSize:20, color:'lightgrey'}}></td>
                                                  }
                                                  <td style={this.state.colorDark ? {color: 'white'} : {color: 'black'}}>{todo.code}</td>
                                                  <td style={this.state.colorDark ? {color: 'white'} : {color: 'black'}}>{todo.description}</td>
                                                  <td>
                                                      <FormCheckbox
                                                          inline
                                                          checked={todo.paymentform}
                                                          onChange={e=>this.handleChangeRole(e, "paymentform", i, todo.code)}
                                                          disabled={true}
                                                      >
                                                      </FormCheckbox>
                                                  </td>
                                                  <td>
                                                      <FormCheckbox
                                                          inline
                                                          checked={todo.participants}
                                                          onChange={e=>this.handleChangeRole(e, "participants", i, todo.code)}
                                                          disabled={true}
                                                      >
                                                      </FormCheckbox>
                                                  </td>
                                                  <td>
                                                      <FormCheckbox
                                                          inline
                                                          checked={todo.pay}
                                                          onChange={e=>this.handleChangeRole(e, "pay", i, todo.code)}
                                                          disabled={disables}
                                                      >
                                                      </FormCheckbox>
                                                  </td>
                                                  <td>
                                                      <FormCheckbox
                                                          inline
                                                          checked={todo.deliverable}
                                                          onChange={e=>this.handleChangeRole(e, "deliverable", i, todo.code)}
                                                          disabled={true}
                                                      >
                                                      </FormCheckbox>
                                                  </td>
                                                  <td>
                                                      <FormCheckbox
                                                          inline
                                                          checked={todo.trace}
                                                          onChange={e=>this.handleChangeRole(e, "trace", i, todo.code)}
                                                          disabled={true}
                                                      >
                                                      </FormCheckbox>
                                                  </td>
                                                  <td>
                                                      <FormCheckbox
                                                          inline
                                                          checked={todo.network}
                                                          onChange={e=>this.handleChangeRole(e, "network", i, todo.code)}
                                                          disabled={disables}
                                                      >
                                                      </FormCheckbox>
                                                  </td>
                                                  <td>
                                                      <FormCheckbox
                                                          inline
                                                          checked={todo.addons}
                                                          onChange={e=>this.handleChangeRole(e, "addons", i, todo.code)}
                                                          disabled={true}
                                                      >
                                                      </FormCheckbox>
                                                  </td>
                                                  <td>
                                                      <FormCheckbox
                                                          inline
                                                          checked={todo.certificates}
                                                          onChange={e=>this.handleChangeRole(e, "certificates", i, todo.code)}
                                                          disabled={true}
                                                      >
                                                      </FormCheckbox>
                                                  </td>
                                                  {buttons ?
                                                    <React.Fragment>
                                                      <td><Button pill theme="success" onClick={e=>this.clickEditMasterFile(e, i)}><FontAwesomeIcon icon={faEdit} /></Button></td>
                                                      <td><Button pill theme="danger" onClick={e=>this.clickRemoveMasterFile(e, i, todo.code)}><FontAwesomeIcon icon={faTimes} /></Button></td>
                                                    </React.Fragment>
                                                  :
                                                    <React.Fragment>
                                                      <td></td>
                                                      <td></td>
                                                    </React.Fragment>
                                                  }
                                              </tr>
                                           )})}
                                      </tbody>
                                    </Table>
                           : null }
                          </Col>
                        </Row>
                      </Form>
                    </Col>
                  </Row>
              : null }

              {selectedTag ?
                  <Row>
                    <Col>
                      <Form style={{fontSize:13}}>
                        <Row form>
                          <Col md="12">
                            <label>&nbsp;</label>
                            <NewMasterFile typeMasterFile={this.state.typeRole} crearMasterFile={this.crearMasterFile} opcionMasterFile={this.state.opcionRole} jsonBlockstack={this.state.jsonBlockstack} code={this.state.code} colorletter={this.state.colorletter} hex={this.state.hex} description={this.state.description} color={this.state.color} jsonRol={this.state.jsonRol} modifying={this.state.modifying} colorDark={this.state.colorDark} />
                          </Col>
                        </Row>
                        <Row>
                          <Col md="12">
                            <label>&nbsp;</label>
                            {this.state.displayTag ?
                                   <Table size="sm" className="text-center" responsive hover striped>
                                      <thead>
                                        <tr>
                                          <th style={{ width: "30px" }}><FormattedMessage id="configuration.description" /></th>
                                          <th style={{ width: "160px"}}><FormattedMessage id="configuration.color" /></th>
                                          <th style={{ width: "160px"}}>Hex</th>
                                          <th style={{ width: "20px" }}><FormattedMessage id="configuration.edit" /></th>
                                          <th style={{ width: "20px" }}><FormattedMessage id="configuration.delete" /></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {jsonBlockstack.map((todo, i) => {
                                          if (todo.colorletter === undefined){todo.colorletter = 'blank'}
                                          return (
                                              <tr key={i}>
                                                  <td style={this.state.colorDark ? {color: 'white'} : {color: 'black'}}>{todo.code}</td>
                                                  <td style={this.state.colorDark ? {color: 'white'} : {color: 'black'}}>{todo.description}</td>
                                                  <td><Card small style={{ backgroundColor: todo.hex, color: todo.colorletter }}>{todo.code}</Card></td>
                                                  <td><Button pill theme="success" onClick={e=>this.clickEditMasterFile(e, i)}><FontAwesomeIcon icon={faEdit} /></Button></td>
                                                  <td><Button pill theme="danger" onClick={e=>this.clickRemoveMasterFile(e, i, todo.code)}><FontAwesomeIcon icon={faTimes} /></Button></td>
                                              </tr>
                                           )})}
                                      </tbody>
                                    </Table>
                           : null }
                          </Col>
                        </Row>
                      </Form>
                    </Col>
                  </Row>
              : null }


              {selectedGeneral ?
                  <Row>
                    <Col>
                      <Form style={ this.state.colorDark ? { backgroundColor:'#0b151d', fontSize:13} : {fontSize:13}}>
                        <Row form>
                          <Col md="1"></Col>
                          <Col md="4">
                            <label>&nbsp;</label>
                            <FormSelect
                                id="TypeSetting"
                                style={ this.state.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                innerRef={this.c01Setting}
                                placeholder="Select an Option"
                                onChange={this.goSetting}
                            >
                                <option value="SelectOptionSetting" selected disabled hidden>{placeholderX1}</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="StacksNetwork">Stacks (STX) Network</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="CryptoCurrencyOrigin">Preferred Crypto Currency of Origin</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="CryptoCurrency">Preferred Crypto Currency Payment</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="FIACurrency">Preferred FIAT Money of Origin</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="LanguageOrigin">Language Origin (From Browser or Configuration)</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="LanguageDisplay">Language Display (ISO Code or Flag)</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="ColorTheme">Color Theme (Blue, Green, Grey or Dark)</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="DisplayCompanyLogoData">Display Logo and Company Data in Documents</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="DisplayChat">Display Chat when editing Document</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="ViewDataSimulator">View Data Simulator</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="ProfileMode">Profile Mode (Simple / Full)</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="LandingPage">Include Landing Page (Yes / No)</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="DisabledInvitationFinances">Disabled Menu 'My Invitations' and 'My Finances' (Yes / No)</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="CompressedSidebar">Compressed Sidebar (Yes / No)</option>
                                <option value="DateFormat" disabled={true}>Date Format</option>
                                <option value="ShowTime" disabled={true}>Show Time</option>
                                <option value="PortsTime" disabled={true}>Ports Time</option>
                                <option value="BringContractTemplateFrom" disabled={true}>Bring Contract Template From (Server or Local)</option>
                                <option value="DocumentSidebarStartsOpen" disabled={true}>Document Sidebar Starts Open</option>
                            </FormSelect>
                          </Col>

                          <Col md="3">
                            <label>&nbsp;</label>
                            {this.state.modeSetting1 ?
                            <FormSelect
                                id="ModeSetting"
                                style={ this.state.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                innerRef={this.c02Setting}
                                placeholder="Select an Option"
                                onChange={this.newSetting}
                            >
                                <option value="SelectModeSetting" selected disabled hidden>{placeholderX1}</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="yyyy-mm-dd">yyyy-mm-dd</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="mm-dd-yyyy">mm-dd-yyyy</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="dd-mm-yyyy">dd-mm-yyyy</option>
                            </FormSelect>
                            : null }

                            {this.state.modeSetting2 ?
                                <FormSelect
                                  id="ModeSetting"
                                  style={ this.state.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                  innerRef={this.c02Setting}
                                  placeholder="Select an Option"
                                  onChange={this.newSetting}
                              >
                                <option value="SelectModeSetting" selected disabled hidden>{placeholderX1}</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="MT-My Local Time">My Local Time</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="LT-Ports Local Time">Port's Local Time</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="UTC-Cordinated Universal Time">Cordinated Universal Time</option>
                              </FormSelect>
                            : null }
                            {this.state.modeSetting3 ?
                              <FormSelect
                                  id="ModeSetting"
                                  style={ this.state.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                  innerRef={this.c02Setting}
                                  placeholder="Select an Option"
                                  onChange={this.newSetting}
                              >
                                <option value="SelectModeSetting" selected disabled hidden>{placeholderX1}</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="MT-My Local Time">My Local Time</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="UTC-Cordinated Universal Time">Cordinated Universal Time</option>
                            </FormSelect>
                            : null }
                            {this.state.modeSetting4 ?
                              <FormSelect
                                  id="ModeSetting"
                                  style={ this.state.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                  innerRef={this.c02Setting}
                                  placeholder="Select an Option"
                                  onChange={this.newSetting}
                              >
                                <option value="SelectModeSetting" selected disabled hidden>{placeholderX1}</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="Yes">Yes</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="No">No</option>
                            </FormSelect>
                            : null }
                            {this.state.modeSetting5 ?
                              <FormSelect
                                  id="ModeSetting"
                                  style={ this.state.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                  innerRef={this.c02Setting}
                                  placeholder="Select an Option"
                                  onChange={this.newSetting}
                              >
                                <option value="StacksNetwork" selected disabled hidden>{placeholderX1}</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="MainNet">MainNet</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="TestNet">TestNet</option>
                            </FormSelect>
                            : null }
                            {this.state.modeSetting6 ?
                              <FormSelect
                                  id="ModeSetting"
                                  style={ this.state.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                  innerRef={this.c02Setting}
                                  placeholder="Select an Option"
                                  onChange={this.newSetting}
                              >
                                <option value="SelectModeSetting" selected disabled hidden>{placeholderX1}</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="Local">Local</option>
                            </FormSelect>
                            : null }
                            {this.state.modeSetting7 ?
                              <FormSelect
                                  id="ModeSetting"
                                  style={ this.state.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                  innerRef={this.c02Setting}
                                  placeholder="Select an Option"
                                  onChange={this.newSetting}
                              >
                                <option value="SelectModeSetting" selected disabled hidden>{placeholderX1}</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="Flag">Flag</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="ISO Code">ISO Code</option>
                            </FormSelect>
                            : null }
                            {this.state.modeSetting8 ?
                              <FormSelect
                                  id="ModeSetting"
                                  style={ this.state.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                  innerRef={this.c02Setting}
                                  placeholder="Select an Option"
                                  onChange={this.newSetting}
                              >
                                <option value="SelectModeSetting" selected disabled hidden>{placeholderX1}</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="Blue">Blue</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="Green">Green</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="Grey">Grey</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="Dark">Dark</option>
                            </FormSelect>
                            : null }
                            {this.state.modeSetting9 ?
                              <FormSelect
                                  id="ModeSetting"
                                  style={ this.state.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                  innerRef={this.c02Setting}
                                  placeholder="Select an Option"
                                  onChange={this.newSetting}
                              >
                                <option value="SelectModeSetting" selected disabled hidden>{placeholderX1}</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="From Browser">From Browser</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="From Configuration">From Configuration</option>
                            </FormSelect>
                            : null }
                            {this.state.modeSetting10 ?
                              <FormSelect
                                  id="ModeSetting"
                                  style={ this.state.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                  innerRef={this.c02Setting}
                                  placeholder="Select an Option"
                                  onChange={this.newSetting}
                              >
                                <option value="SelectModeSetting" selected disabled hidden>{placeholderX1}</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="Tab">Tab</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="Numeric">Numeric</option>
                            </FormSelect>
                            : null }
                            {this.state.modeSetting11 ?
                              <FormSelect
                                  id="ModeSetting"
                                  style={ this.state.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                  innerRef={this.c02Setting}
                                  placeholder="Select an Option"
                                  onChange={this.newSetting}
                              >
                                <option value="SelectModeSetting" selected disabled hidden>{placeholderX1}</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="Yes">Yes</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="No">No</option>
                            </FormSelect>
                            : null }
                            {this.state.modeSetting12 ?
                              <FormSelect
                                  id="ModeSetting"
                                  style={ this.state.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                  innerRef={this.c02Setting}
                                  placeholder="Select an Option"
                                  onChange={this.newSetting}
                              >
                              {currencyX.map((todo, i) => {
                                return (
                                  <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} key={i} value={`${todo.Ccy} - ${todo.CcyNm}`}>{`${todo.Ccy} - ${todo.CcyNm}`}</option>
                                )
                              })}
                            </FormSelect>
                            : null }
                            {this.state.modeSetting13 ?
                              <FormSelect
                                  id="ModeSetting"
                                  style={ this.state.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                  innerRef={this.c02Setting}
                                  placeholder="Select an Option"
                                  onChange={this.newSetting}
                              >
                              <option value="SelectModeSetting" selected disabled hidden>{placeholderX1}</option>
                              <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="Yes">Yes</option>
                              <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="No">No</option>
                            </FormSelect>
                            : null }
                            {this.state.modeSetting14 ?
                              <FormSelect
                                  id="ModeSetting"
                                  style={ this.state.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                  innerRef={this.c02Setting}
                                  placeholder="Select an Option"
                                  onChange={this.newSetting}
                              >
                              {currencyCryptoX.map((todo, i) => {
                                return (
                                  <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} key={i} value={`${todo.Ccy} - ${todo.CcyNm}`}>{`${todo.Ccy} - ${todo.CcyNm}`}</option>
                                )
                              })}
                            </FormSelect>
                            : null }
                            {this.state.modeSetting15 ?
                              <FormSelect
                                  id="ModeSetting"
                                  style={ this.state.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                  innerRef={this.c02Setting}
                                  placeholder="Select an Option"
                                  onChange={this.newSetting}
                              >
                              {currencyPaymentX.map((todo, i) => {
                                return (
                                  <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} key={i} value={`${todo.Ccy} - ${todo.CcyNm}`}>{`${todo.Ccy} - ${todo.CcyNm}`}</option>
                                )
                              })}
                            </FormSelect>
                            : null }
                            {this.state.modeSetting16 ?
                              <FormSelect
                                  id="ModeSetting"
                                  style={ this.state.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                  innerRef={this.c02Setting}
                                  placeholder="Select an Option"
                                  onChange={this.newSetting}
                              >
                                <option value="SelectModeSetting" selected disabled hidden>{placeholderX1}</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="Yes">Yes</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="No">No</option>
                            </FormSelect>
                            : null }
                            {this.state.modeSetting17 ?
                              <FormSelect
                                  id="ModeSetting"
                                  style={ this.state.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                  innerRef={this.c02Setting}
                                  placeholder="Select an Option"
                                  onChange={this.newSetting}
                              >
                                <option value="SelectModeSetting" selected disabled hidden>{placeholderX1}</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="Simple">Simple</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="Full">Full</option>
                            </FormSelect>
                            : null }
                            {this.state.modeSetting18 ?
                              <FormSelect
                                  id="ModeSetting"
                                  style={ this.state.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                  innerRef={this.c02Setting}
                                  placeholder="Select an Option"
                                  onChange={this.newSetting}
                              >
                                <option value="SelectModeSetting" selected disabled hidden>{placeholderX1}</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="Yes">Yes</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="No">No</option>
                            </FormSelect>
                            : null }
                            {this.state.modeSetting19 ?
                              <FormSelect
                                  id="ModeSetting"
                                  style={ this.state.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                  innerRef={this.c02Setting}
                                  placeholder="Select an Option"
                                  onChange={this.newSetting}
                              >
                                <option value="SelectModeSetting" selected disabled hidden>{placeholderX1}</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="Yes">Yes</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="No">No</option>
                            </FormSelect>
                            : null }
                            {this.state.modeSetting20 ?
                              <FormSelect
                                  id="ModeSetting"
                                  style={ this.state.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                                  innerRef={this.c02Setting}
                                  placeholder="Select an Option"
                                  onChange={this.newSetting}
                              >
                                <option value="SelectModeSetting" selected disabled hidden>{placeholderX1}</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="Yes">Yes</option>
                                <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} value="No">No</option>
                            </FormSelect>
                            : null }

                          </Col>
                          <Col md="2"></Col>
                          <Col md="2">
                            <label>&nbsp;</label>
                            <br></br>
                            <Button outline pill theme="warning" size="sm" className="mb-2" onClick={this.resetSetting}>
                                <i className="material-icons mr-1">replay</i> <FormattedMessage id="configuration.reset" />
                            </Button>
                          </Col>
                        </Row>
                        <Row>
                          <Col md="1"></Col>
                          <Col md="10">
                            <label>&nbsp;</label>
                            {this.state.displaySetting ?
                                  <Table size="sm" responsive hover striped>
                                      <thead>
                                        <tr>
                                          <th style={{fontSize:15}}><FormattedMessage id="configuration.description" /></th>
                                          <th style={{fontSize:15}}><FormattedMessage id="configuration.value" /></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {jsonBlockstackY.map((todo, i) => {
                                           let displayButtonDelete = false
                                           if (todo.code !=="DateFormat" && todo.code !== "ShowTime" && todo.code !== "PortsTime" && todo.code !== "BringContractTemplateFrom" &&
                                              todo.code !== "DocumentSidebarStartsOpen" && todo.code !== "EncryptDecryptFile"){
                                                return (
                                                  <tr key={i}>
                                                      <td style={this.state.colorDark ? {color: 'white'} : {color: 'black'}}>{todo.concept}</td>
                                                      <td style={this.state.colorDark ? {color: 'orange'} : {color: 'orange'}}>{todo.description}</td>
                                                  </tr>
                                                )}
                                            }
                                        )}
                                      </tbody>
                                  </Table>
                           : null }
                          </Col>
                          <Col md="1"></Col>
                        </Row>
                      </Form>
                    </Col>

                  </Row>
              : null }
              { selectedIoTDevice ?
                <Row>
                  <Col>
                    <Form style={{fontSize:13}}>
                      <Row form>
                        <Col md="1"></Col>
                        <Col md="3">
                          <label htmlFor="TypeIoTDevice"><FormattedMessage id="configuration.iotdevice" /> (*)</label>
                          <FormSelect
                              id="TypeIoTDevice"
                              style={ this.state.colorDark ? { backgroundColor:'#111f2c', color:'white'} : {}}
                              innerRef={this.c01IoTDevice}
                              placeholder="Select an Option"
                              onChange={this.goIoTDevice}
                          >
                          <option value="SelectOptionMasterFile" selected disabled hidden>{placeholderX1}</option>
                          {jsonBlockstack.map((todo, i) => (
                              <option style={this.state.colorDark ? {color:'orange'} : {color:'darkblue'}} key={i} value={todo.code}>{todo.code} - {todo.description}</option>
                          ))}
                          </FormSelect>
                        </Col>

                        <Col md="3">
                          <label></label>
                          {this.state.displayIoTDevice ?
                            <NewIoTDevice idx={idx} typeIoTDevice={this.state.typeIoTDevice} crearIoTDevice={this.crearIoTDevice} opcionIoTDevice={this.state.opcionIoTDevice} colorDark={ this.state.colorDark} />
                         : null }
                        </Col>
                      </Row>
                      <Row>
                        <Col md="1"></Col>
                        <Col md="10">
                          <label>&nbsp;</label>
                          {this.state.displayIoTDevice2 ?
                                 <Table size="sm" className="text-center" responsive hover striped>
                                    <thead>
                                      <tr>
                                        <th><FormattedMessage id="configuration.code" /></th>
                                        <th><FormattedMessage id="configuration.description" /></th>
                                        <th><FormattedMessage id="configuration.delete" /></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {jsonBlockstackZ.map((todo, i) => (
                                      <tr key={i}>
                                          <td style={this.state.colorDark ? {color: 'white'} : {color: 'black'}}>{todo.code}</td>
                                          <td style={this.state.colorDark ? {color: 'white'} : {color: 'black'}}>{todo.description}</td>
                                          <td><Button pill theme="danger" onClick={e=>this.clickRemoveIoTDevice(e, i)}><FontAwesomeIcon icon={faTimes} /></Button></td>
                                      </tr>
                                      ))}
                                    </tbody>
                                  </Table>
                         : null }
                        </Col>
                        <Col md="1"></Col>
                      </Row>
                    </Form>
                  </Col>

                </Row>

              : null }
              { selectedRBackupRestore ?
                <Row>
                  <Col>
                    <Form style={{fontSize:13}}>
                      <Row form></Row>
                      <Row form>
                        <Col md="2"></Col>
                        <Col md="8">
                            <Table size="sm" className="text-left" responsive hover striped>
                               <thead>
                                 <tr>
                                   <th style={{width: "17%"}}><Button pill theme="success" disabled={!this.state.sendfiles} onClick={e=>this.backupRestoreConfirm0(e)}>Read Files</Button></th>
                                   <th style={{width: "17%"}}><Button pill theme="primary" disabled={!this.state.completedata} onClick={e=>this.backupRestoreConfirm2(e, this.state.jsonBackupRestore)}>Complete Data</Button></th>
                                   <th style={{width: "17%"}}><Button pill theme="warning" disabled={!this.state.backupfiles} onClick={e=>this.clickDownload(e)}>Download Files</Button></th>
                                   <th style={{width: "17%"}}><Button pill theme="light" disabled={!this.state.uploadfiles} onClick={e=>this.clickUpload(e)}>Upload Files</Button></th>
                                   <th style={{width: "16%"}}><Button pill theme="danger" disabled={!this.state.restorefiles} onClick={e=>this.recoveryRestoreConfirm2(e, this.state.jsonBackupRestore)}>Recovery Files</Button></th>
                                   <th style={{width: "16%"}}><Button pill theme="dark" disabled={!this.state.exitprogram} onClick={e=>this.clickExit(e)}>Exit</Button></th>
                                 </tr>
                               </thead>
                             </Table>
                         </Col>
                         <Col md="2"></Col>
                       </Row>
                       {this.state.attachJson ?
                           <>
                             <Row>&nbsp;</Row>
                             <Row>
                               <Col md="2"></Col>
                               <Col md="8">
                                   <NewMasterFileContractUpload returnUploadContract={this.returnUploadContract} colorDark={ this.props.colorDark} mimeTypeX={mimeTypeX} />
                               </Col>
                               <Col md="2"></Col>
                             </Row>
                             <Row>&nbsp;</Row>
                           </>
                       : null
                       }
                       <Row form></Row>
                       <Row form>
                         <Col md="2"></Col>
                       <Col md="8">
                           <Table size="sm" className="text-left" responsive hover striped>
                              <thead>
                                <tr>
                                  <th style={{width: "5%"}}>Item</th>
                                  <th style={{width: "20%"}}>Filename</th>
                                  <th className="text-center"  style={{width: "5%"}}>Find</th>
                                  <th className="text-center"  style={{width: "5%"}}>See</th>
                                  <th style={{width: "55%"}}>Data</th>
                                  <th style={{width: "10%"}}>Recovery</th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.displayLoader ?
                                  <>
                                  <td><ContractLoader colorDark={this.state.colorDark}/></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  <td></td>
                                  </>
                                :
                                  <>
                                    {this.state.jsonBackupRestore.map((todo, i) => {
                                      let datahiddenX = ''
                                      if (todo.datahidden !== null) {
                                        if  (todo.datahidden.length > 30){
                                            datahiddenX = `${todo.datahidden.substring(0,15)}...${todo.datahidden.substring(todo.datahidden.length-15)}`
                                        } else {
                                            datahiddenX = todo.datahidden
                                        }
                                      }
                                      return (
                                        <tr key={i}>
                                            <td style={this.state.colorDark ? {width: "5%", color: 'white'} : {width: "5%", color: 'black'}}>{todo.item}</td>
                                            <td style={this.state.colorDark ? {width: "20%", color: 'white'} : {width: "20%", color: 'black'}}>{todo.namefile}</td>
                                            {todo.dataobject ?
                                              <>
                                                <td className="text-center" style={this.state.colorDark ? {width: "5%", color: 'white'} : {width: "5%", color: 'black'}}>
                                                    <FormCheckbox
                                                        inline
                                                        checked={todo.dataobject}
                                                        disabled={true}
                                                    >
                                                    </FormCheckbox>
                                                </td>
                                                <td className="text-center" style={{width: "5%"}}><Button outline pill theme="info" onClick={e=>this.clickSee(e,todo.datahidden)}>See</Button></td>
                                              </>
                                            :
                                              <>
                                                <td style={{width: "5%"}}></td>
                                                <td style={{width: "5%"}}></td>
                                              </>
                                            }
                                            <td style={this.state.colorDark ? {width: "55%", color: 'white'} : {width: "55%", color: 'black'}}>{datahiddenX}</td>

                                            {todo.recoveryobject ?
                                              <>
                                                <td className="text-center" style={this.state.colorDark ? {width: "10%", color: 'white'} : {width: "10%", color: 'black'}}>
                                                    <FormCheckbox
                                                        inline
                                                        checked={todo.recoveryobject}
                                                        disabled={true}
                                                    >
                                                    </FormCheckbox>
                                                </td>
                                              </>
                                            :
                                              <>
                                                <td style={{width: "10%"}}></td>
                                              </>
                                            }
                                        </tr>
                                    )})}
                                  </>
                                }
                              </tbody>
                            </Table>
                        </Col>
                        <Col md="2"></Col>
                      </Row>
                    </Form>
                  </Col>
                </Row>
              : null }

              <br></br>

            </Container>
          </>
        );
    }
}

export default withRouter(ConntenedorMasterFile);
